<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';
  import SelecaoBusca from './SelecaoBusca.vue';
  import ComplementoSugerido from './ComplementoSugerido.vue';
  import sugestoesDoHistorico, { continuacaoDoHistorico, sugestoesDaContraparte, nomeDoHistorico } from '../sugestoes-historico';
  import RateioProjetos from './RateioProjetos.vue';
  import OrigensTransferencia, { novaOrigemTransferencia } from './OrigensTransferencia.vue';
  import BlocoOperacao from './BlocoOperacao.vue';
  import ContasReceberVinculadas, { somaContasReceber } from './ContasReceberVinculadas.vue';
  import NotaFiscalVinculo from './NotaFiscalVinculo.vue';
  import DevolucaoSolicitacaoVinculo from './DevolucaoSolicitacaoVinculo.vue';
  import AnexosOperacao from './AnexosOperacao.vue';
  import anexosMixin, { DESTINO_LANCAMENTO, DESTINO_CONTA_RECEBER, DESTINO_SOLICITACAO } from '../anexos';

  let sequenciaTitulo = 0;

  function novoTituloCr() {
    sequenciaTitulo += 1;
    return {
      chave: sequenciaTitulo,
      tipoPessoa: 0, idTerceiro: 0, nomeTerceiro: '', historico: '',
      rateios: [],
      idCategoriaFinanceira: 0, nomeCategoriaFinanceira: '',
      documento: '', complemento: '',
      notaFiscal: null,
      devolucao: null,
      valor: 0, valorTexto: '',
      taxa: { mostrar: false, marcado: false, chave: '' },
      anexos: [],
    };
  }

  export default {
    components: { SelecaoBusca, DatePicker, ComplementoSugerido, RateioProjetos, OrigensTransferencia,
                  BlocoOperacao, AnexosOperacao, ContasReceberVinculadas, NotaFiscalVinculo,
                  DevolucaoSolicitacaoVinculo },
    mixins: [anexosMixin],
    props: {
      idContaCript: { type: String, required: true },
      deteccao: { type: Object, required: true },
    },
    data() {
      return {
        operacao: '',
        gravando: false,
        validar: false,
        carregandoAplicacoes: false,
        carregandoConfig: true,
        configCredito: null,
        aplicacoes: [],
        textosDocumento: [],
        textosComplemento: [],
        textosHistorico: [],
        anexos: {
          movimento: [],
          contaReceber: [],
          creditoContaReceber: [],
        },
        viaSolicitacao: true,
        taxaMov: { mostrar: false, marcado: false },
        taxaRegCr: { mostrar: false, marcado: false },
        semRateioConta: false,
        semRateioCr: false,
        origensValidas: false,
        destinosValidos: false,
        observacaoSugerida: '',
        pedidoObservacao: 0,
        form: {
          origens: [novaOrigemTransferencia(0)],
          data: null,
          documento: '',
          complemento: '',
          gerarDebitoTransitoria: false,
          idUsuarioLiberacao: 0,
          nomeUsuarioLiberacao: '',
          observacao: '',
          justificativa: '',
          idAplicacao: 0,
          idTipoAplicacao: 0,
          nomeTipoAplicacao: '',
          idProjeto: 0,
          nomeProjeto: '',
        },
        mov: {
          tipoPessoa: 0, idTerceiro: 0, nomeTerceiro: '', historico: '',
          rateios: [],
          idCategoriaFinanceira: 0, nomeCategoriaFinanceira: '',
          formaPagamento: -1,
          documento: '', complemento: '',
          notaFiscal: null,
          devolucao: null,
          valor: 0, valorTexto: '',
          anexos: [],
        },
        movExtras: [],
        crc: {
          dataEmissao: new Date(), dataVencimento: null,
          baixarAgora: true,
          titulos: [novoTituloCr()],
        },
        reg: {
          tipo: 'sem-identificacao',
          idContaOrigem: 0,
          nomeContaOrigem: '',
          documento: '',
          complemento: '',
          destinos: [novaOrigemTransferencia(0)],
          vinculados: [],
          cr: {
            rateios: [],
            idConta: 0, nomeConta: '',
            tipoPessoa: 0, idTerceiro: 0, nomeTerceiro: '', historico: '',
            idCategoriaFinanceira: 0, nomeCategoriaFinanceira: '',
            dataEmissao: new Date(), dataVencimento: null,
            documento: '', complemento: '',
            notaFiscal: null,
            valor: 0, valorTexto: '',
          },
        },
        crExtras: [],
      }
    },
    computed: {
      podeAnexarPerna() { return this.viaSolicitacao ? this.podeAnexarSolicitacao : this.podeAnexarLancamento; },
      anexosAtivos() {
        if (this.ehTransferencia) return this.anexosDosBlocos(this.form.origens);
        if (this.ehMovimento) return this.anexosDosBlocos(this.lancamentosMov);
        if (this.ehContaReceberConta) return this.anexosDosBlocos(this.crc.titulos);
        if (this.ehCreditoIdentificar)
          return (this.regExigeContaReceber ? this.anexos.creditoContaReceber.concat(this.anexosDosBlocos(this.crExtras)) : [])
            .concat(this.regExigeTransferencia ? this.anexosDosBlocos(this.reg.destinos) : []);
        return [];
      },
      origensLinha() {
        return this.origensAnexo({ idExtrato: this.deteccao.idExtrato, idsContaReceber: this.vinculadosEnvio.map(c => c.idLancamento) });
      },
      anexoTransferencia() {
        if (!this.podeAnexarPerna) return null;

        return {
          origens: this.origensLinha,
          limite: this.limiteAnexo,
          titulo: this.tituloAnexoTransferencia,
          dica: this.dicaAnexoTransferencia,
        };
      },
      totalAnexos() { return this.anexosAtivos.length; },
      chaveTaxaMov() {
        return this.ehMovimento && this.creditoNoExtrato ? this.chaveTaxa(this.mov) : '';
      },
      chaveTaxaRegCr() {
        return this.ehCreditoIdentificar && this.regExigeContaReceber ? this.chaveTaxa(this.reg.cr) : '';
      },
      chavesTaxaCrc() {
        return this.crc.titulos.map(t => this.ehContaReceberConta && this.crc.baixarAgora ? this.chaveTaxa(t) : '').join(';');
      },
      variosTitulos() { return this.crc.titulos.length > 1; },
      variosCr() { return this.crExtras.length > 0; },
      titulosRegCr() { return [this.reg.cr].concat(this.crExtras); },
      somaRegCr() {
        return Math.round(this.titulosRegCr.reduce((s, t) => s + this.valorRegCr(t), 0) * 100) / 100;
      },
      faltaRegCr() { return Math.round((this.deteccao.valor - this.somaRegCr) * 100) / 100; },
      chavesTaxaCrExtras() {
        return this.crExtras.map(t => this.regExigeContaReceber ? this.chaveTaxa(t) : '').join(';');
      },
      variasLinhas() { return (this.deteccao.idsExtrato || []).length > 1; },
      idsExtratoEnvio() { return (this.deteccao.idsExtrato || []).length ? this.deteccao.idsExtrato : [this.deteccao.idExtrato]; },
      variosMovimentos() { return this.movExtras.length > 0; },
      lancamentosMov() { return [this.mov].concat(this.movExtras); },
      somaMovimentos() {
        return Math.round(this.lancamentosMov.reduce((s, m) => s + this.valorDoMov(m), 0) * 100) / 100;
      },
      faltaMovimentos() { return Math.round((this.deteccao.valor - this.somaMovimentos) * 100) / 100; },
      somaTitulos() {
        return Math.round(this.crc.titulos.reduce((s, t) => s + this.valorDoTitulo(t), 0) * 100) / 100;
      },
      faltaTitulos() { return Math.round((this.deteccao.valor - this.somaTitulos) * 100) / 100; },
      notasDosTitulos() { return this.crc.titulos.filter(t => t.notaFiscal).map(t => t.notaFiscal); },
      seloTransferencia() { return this.viaSolicitacao ? 'SOL' : 'TRANSF'; },
      corTransferencia() { return this.viaSolicitacao ? 'amb' : 'azu'; },
      quantasOrigens() {
        return (this.ehCreditoIdentificar ? this.reg.destinos.length : this.form.origens.length) || 1;
      },
      destinoPrincipal() { return this.reg.destinos[0] || null; },
      formasPagamento() {
        return [
          'Gestora', 'Boleto', 'Depósito em cheque', 'Carta débito transferência', 'Carta débito',
          'Boleto cheque', 'Ordem pagamento', 'Pagamento eletrônico', 'Invoice',
        ];
      },
      usaCategoria() { return !!(this.deteccao && this.deteccao.usaCategoriaFinanceira); },
      categoriaObrigatoria() {
        return this.usaCategoria && !!(this.deteccao && this.deteccao.categoriaFinanceiraObrigatoria);
      },
      algumRateioExigeItem() {
        return this.form.origens.some(o =>
          (o.rateiosDebito || []).some(r => r.exigeItem) || (o.rateiosCredito || []).some(r => r.exigeItem));
      },
      contasDaSolicitacao() { return this.ehCreditoIdentificar ? this.reg.destinos : this.form.origens; },
      observacaoPorConta() { return this.viaSolicitacao && this.contasDaSolicitacao.length > 1; },
      projetosRateioCr() {
        if (!this.regExigeContaReceber) return [];
        return (this.reg.cr.rateios || []).filter(r => r.idProjeto > 0).map(r => r.idProjeto);
      },
      destinosEscolhidos() { return this.reg.destinos.filter(d => d.idConta > 0); },
      chaveProjetosDestinos() {
        return this.reg.destinos.map(d => this.chaveProjetos(d.rateiosDebito) + '|' + this.chaveProjetos(d.rateiosCredito)).join(';')
          + '|' + this.projetosRateioCr.join(',');
      },
      subtituloTransferenciaCredito() {
        return this.quantasOrigens > 1
          ? 'Divide o valor da ' + this.nomeContaExtrato + ' entre as contas certas'
          : 'Leva o valor da ' + this.nomeContaExtrato + ' para a conta certa';
      },
      tituloTransferencia() {
        if (this.quantasOrigens > 1)
          return this.viaSolicitacao
            ? this.quantasOrigens + ' solicitações de transferência'
            : this.quantasOrigens + ' transferências entre contas';

        return this.viaSolicitacao ? 'Solicitação de transferência' : 'Transferência entre contas';
      },
      subtituloTransferencia() {
        if (this.viaSolicitacao)
          return this.quantasOrigens > 1
            ? 'Nenhum lançamento agora — cada uma vira transferência quando for liberada'
            : 'Nenhum lançamento agora — vira transferência quando for liberada';

        if (this.ehSaldo)
          return this.quantasOrigens > 1
            ? this.quantasOrigens * 2 + ' pernas lançadas agora, conciliadas com os lançamentos selecionados'
            : 'Duas pernas lançadas agora — a desta conta zera o saldo selecionado';

        return this.quantasOrigens > 1
          ? this.quantasOrigens * 2 + ' pernas lançadas agora, todas conciliadas com a linha do extrato'
          : 'Duas pernas lançadas agora, uma em cada conta';
      },
      tituloAnexoTransferencia() {
        return this.viaSolicitacao ? 'Arquivos da solicitação' : 'Arquivos da transferência';
      },
      dicaAnexoTransferencia() {
        return this.viaSolicitacao
          ? 'Os arquivos vão para a pasta desta solicitação de transferência.'
          : 'Os arquivos vão para a pasta de lançamentos, nas duas pernas desta transferência.';
      },
      ehTransferencia() { return this.operacao === 'transferencia'; },
      ehSaldo() { return !!this.deteccao.saldo; },
      ehComplemento() { return !!this.deteccao.complemento; },
      diasSaldoSelecionado() {
        const dias = (this.deteccao.lancamentosSaldo || []).map(l => l.data);
        return dias.filter((d, i) => dias.indexOf(d) === i).length;
      },
      somaSaldoSelecionado() {
        return (this.deteccao.lancamentosSaldo || []).reduce((s, l) => s + (+l.valor || 0), 0);
      },
      ehResgate() { return this.operacao === 'resgate'; },
      ehAplicacao() { return this.operacao === 'aplicacao'; },
      ehCreditoIdentificar() { return this.operacao === 'credito-identificar'; },
      ehMovimento() { return this.operacao === 'movimento'; },
      ehContaReceberConta() { return this.operacao === 'conta-receber'; },
      semClienteMov() { return this.mov.tipoPessoa === 3; },
      semClienteRegCr() { return this.reg.cr.tipoPessoa === 3; },
      creditoNoExtrato() { return this.deteccao.creditoDebito === 1; },
      ehTarifaDoExtrato() {
        if (this.creditoNoExtrato) return false;
        if (this.deteccao.grupoTarifa) return true;
        return /^\s*(TAR |TARIFA)/i.test(this.deteccao.historico || '');
      },
      titulo() {
        if (this.ehComplemento) return 'Lançar a diferença e conciliar junto';
        if (this.ehSaldo) return 'Transferir o saldo dos lançamentos';
        return this.creditoNoExtrato ? 'Regularizar crédito do extrato' : 'Regularizar débito do extrato';
      },
      rotuloValor() {
        if (this.ehComplemento) return this.creditoNoExtrato ? 'Crédito a lançar' : 'Débito a lançar';
        if (this.ehSaldo) return 'Sobra na conta';
        return this.creditoNoExtrato ? 'Crédito a regularizar' : 'Débito a regularizar';
      },
      perguntaOrigem() {
        if (this.ehComplemento) return 'Como lançar a diferença?';
        if (this.ehSaldo) return 'Para onde vai o saldo?';
        return this.creditoNoExtrato ? 'De onde veio este crédito?' : 'Para onde foi este débito?';
      },
      nomeContaExtrato() { return this.deteccao.nomeConta || 'conta do extrato'; },
      idContaOrigemReg() { return this.reg.idContaOrigem > 0 ? this.reg.idContaOrigem : this.deteccao.idConta; },
      nomeContaOrigemReg() { return this.reg.idContaOrigem > 0 ? (this.reg.nomeContaOrigem || 'conta de origem') : this.nomeContaExtrato; },
      origemRegAlterada() { return this.reg.idContaOrigem > 0 && this.reg.idContaOrigem !== this.deteccao.idConta; },
      operacoesDisponiveis() {
        if (this.ehComplemento)
          return [{
            valor: 'movimento',
            curto: this.creditoNoExtrato ? 'Crédito' : 'Débito',
            icone: this.creditoNoExtrato ? 'fa-plus-circle' : 'fa-minus-circle',
            titulo: 'Lançar a diferença',
            texto: 'Os lançamentos já feitos não mudam — os novos fecham a diferença, cada um com seu rateio, e tudo é conciliado junto com o extrato.',
          }];

        if (this.ehSaldo)
          return [{
            valor: 'transferencia',
            curto: 'Transferir',
            icone: 'fa-exchange',
            titulo: 'Transferir o saldo para outra conta da fundação',
            texto: 'A transferência zera a soma dos lançamentos selecionados e tudo é conciliado junto — pode dividir entre várias contas, com rateio por projeto.',
          }];

        const opcoes = [{
          valor: 'transferencia',
          curto: 'Outra conta',
          icone: 'fa-exchange',
          titulo: 'Outra conta da fundação',
          texto: 'Transferência entre contas — pode dividir o valor entre várias contas, com rateio por projeto.',
        }];

        if (this.creditoNoExtrato && !this.variasLinhas) {
          opcoes.push({
            valor: 'resgate',
            curto: 'Resgate',
            icone: 'fa-undo',
            titulo: 'Aplicação desta conta',
            texto: 'Resgate — lança o resgate e o movimento na conta corrente.',
          });
        }

        if (this.creditoNoExtrato) {
          opcoes.push({
            valor: 'credito-identificar',
            curto: 'A identificar',
            icone: 'fa-question-circle-o',
            titulo: 'Terceiro — crédito a identificar',
            texto: 'Passa pela conta transitória (TRA) até saber de quem é.',
          });
        } else if (!this.variasLinhas) {
          opcoes.push({
            valor: 'aplicacao',
            curto: 'Aplicação',
            icone: 'fa-line-chart',
            titulo: 'Aplicação desta conta',
            texto: 'Aplicação — lança o aporte numa aplicação da conta e o movimento na conta corrente.',
          });
        }

        opcoes.push({
          valor: 'movimento',
          curto: this.creditoNoExtrato ? 'Crédito' : 'Débito',
          icone: this.creditoNoExtrato ? 'fa-plus-circle' : 'fa-minus-circle',
          titulo: this.creditoNoExtrato ? 'Lançar o crédito direto' : 'Lançar o débito direto',
          texto: 'Lançamento direto na conta, com rateio no projeto — sem contas a receber nem a pagar.',
        });

        if (this.creditoNoExtrato) {
          opcoes.push({
            valor: 'conta-receber',
            curto: 'Contas a receber',
            icone: 'fa-file-text-o',
            titulo: 'Contas a receber desta conta',
            texto: 'Cria o título nesta conta — baixado agora com o crédito, ou em aberto.',
          });
        }

        return opcoes;
      },
      operacaoAtiva() {
        return this.operacoesDisponiveis.filter(o => o.valor === this.operacao)[0] || null;
      },
      subcasosCredito() {
        return [
          { valor: 'sem-identificacao', curto: 'Nada ainda', titulo: 'Nada ainda', texto: 'Só a regularização na conta transitória.' },
          { valor: 'sem-conta-receber', curto: 'Sei o cliente', titulo: 'Sei o cliente — falta o contas a receber', texto: 'Cria o título e a transferência.' },
          { valor: 'conta-errada', curto: 'Conta errada', titulo: 'O título já existe, entrou na conta errada', texto: 'A transferência para a conta certa e, se quiser, o vínculo com o contas a receber que já existe.' },
        ];
      },
      subcasoAtivo() {
        return this.subcasosCredito.filter(s => s.valor === this.reg.tipo)[0] || null;
      },
      aplicacoesAporte() {
        return this.aplicacoes.filter(a => a.saldo > 0.005 || !a.qtdeOperacoes);
      },
      aplicacoesDaOperacao() {
        return this.ehAplicacao ? this.aplicacoesAporte : this.aplicacoes;
      },
      aplicacaoEscolhida() {
        return this.aplicacoes.filter(a => a.idAplicacao === this.form.idAplicacao)[0] || null;
      },
      regExigeTransferencia() {
        return this.ehCreditoIdentificar && (this.reg.tipo === 'sem-conta-receber' || this.reg.tipo === 'conta-errada');
      },
      regExigeContaReceber() {
        return this.ehCreditoIdentificar && this.reg.tipo === 'sem-conta-receber';
      },
      regVinculaContaReceber() {
        return this.ehCreditoIdentificar && this.reg.tipo === 'conta-errada';
      },
      vinculadosEnvio() {
        return this.regVinculaContaReceber ? this.reg.vinculados : [];
      },
      buscaInicialCr() {
        const documento = (this.deteccao.cpfcnpj || '').replace(/[^A-Za-z0-9]/g, '');
        if (documento && !this.deteccao.contraparteFundacao) return documento;
        return this.nomeExtrato;
      },
      nomeExtrato() {
        const gravado = (this.deteccao.nomeContraparte || '').trim();
        if (gravado) return gravado;
        const contraparte = this.contraparteDoExtrato();
        return (contraparte && contraparte.nome) || nomeDoHistorico(this.deteccao.historico);
      },
      raizCnpjExtrato() {
        const documento = (this.deteccao.cpfcnpj || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        if (documento.length !== 14 || this.deteccao.contraparteFundacao) return '';
        return documento.slice(0, 2) + '.' + documento.slice(2, 5) + '.' + documento.slice(5, 8);
      },
      sugestoesSp() {
        const texto = [this.deteccao.historico, this.deteccao.documento].filter(t => !!t).join(' ');
        const lista = [];
        const regex = /(?:^|[^A-Z])S\s*([PBDR])\.?\s*(\d{4,7})(?!\d)/gi;
        let achado = regex.exec(texto);
        while (achado) {
          const sugestao = 'S' + achado[1].toUpperCase() + ' ' + achado[2];
          if (lista.indexOf(sugestao) < 0) lista.push(sugestao);
          achado = regex.exec(texto);
        }
        return lista;
      },
      sugestoesNf() {
        return [this.raizCnpjExtrato, this.buscaInicialCr].concat(this.sugestoesCr).filter(t => !!t);
      },
      sugestoesCr() {
        return [this.nomeExtrato];
      },
      pedeLiberacao() {
        return this.viaSolicitacao && (this.ehTransferencia || this.regExigeTransferencia);
      },
      configurado() { return !!(this.configCredito && this.configCredito.configurado); },
      contaTransitoria() { return (this.configCredito && this.configCredito.nomeConta) || 'conta transitória (TRA)'; },
      rubricaCredito() {
        if (!this.configCredito) return '';
        return [this.configCredito.nomeRubrica, this.configCredito.nomeSubrubrica].filter(t => !!t).join(' · ');
      },
      rubricaDebito() {
        if (!this.configCredito) return '';
        return [this.configCredito.nomeRubricaDebito, this.configCredito.nomeSubrubricaDebito].filter(t => !!t).join(' · ');
      },
      sugestoesComplemento() { return sugestoesDoHistorico(this.deteccao.historico, 300); },
      sugestoesTraDocumento() {
        const contraparte = this.contraparteDoExtrato();
        if (!contraparte || !contraparte.nome) return [];
        return sugestoesDaContraparte(this.deteccao.historico, contraparte.documento, contraparte.nome, 50,
          `${this.deteccao.prefixoTra || 'TRA'} - `);
      },
      sugestoesTraComplemento() {
        const contraparte = this.contraparteDoExtrato();
        const daContraparte = contraparte && contraparte.nome
          ? sugestoesDaContraparte(this.deteccao.historico, contraparte.documento, contraparte.nome, 300,
            `${this.deteccao.prefixoTra || 'TRA'} - `)
          : [];
        return daContraparte.concat(this.sugestoesComplemento);
      },
      sugestoesHistorico() {
        const contraparte = this.contraparteDoExtrato();
        if (contraparte && contraparte.nome)
          return sugestoesDaContraparte(this.deteccao.historico, contraparte.documento, contraparte.nome, 110)
            .concat(sugestoesDoHistorico(this.deteccao.historico, 110));
        const continuacao = this.deteccao.cpfcnpj ? '' : continuacaoDoHistorico(this.deteccao.historico).slice(0, 110);
        const doExtrato = contraparte ? [(contraparte.documento + ' ' + contraparte.nome).trim()] : continuacao ? [continuacao] : [];
        return doExtrato.concat(sugestoesDoHistorico(this.deteccao.historico, 110));
      },
      previa() {
        const itens = [];
        const valor = this.deteccao.valor;
        const projeto = (this.configCredito && this.configCredito.nomeProjeto) || '';

        if (this.ehTransferencia) {
          const nomeDaOrigem = o => o.nomeConta || 'conta da outra ponta';

          if (this.viaSolicitacao) {
            this.form.origens.forEach((origem, ix) => {
              const rateada = origem.rateiosDebito.length > 0 || origem.rateiosCredito.length > 0;

              itens.push({
                chave: 'solic' + ix, rotulo: 'Solicitação de transferência', cor: 'amb', valor: origem.valor, qtde: 0,
                linha: this.creditoNoExtrato
                  ? `${nomeDaOrigem(origem)} → ${this.nomeContaExtrato}`
                  : `${this.nomeContaExtrato} → ${nomeDaOrigem(origem)}`,
                nota: (rateada ? 'Rateio informado' : 'Nasce sem rateio')
                    + ', aguardando liberação. O lançamento é gerado quando ela for liberada.',
              });
            });
          } else {
            this.form.origens.forEach((origem, ix) => {
              const rateioDaConta = this.creditoNoExtrato ? origem.rateiosCredito : origem.rateiosDebito;
              const rateioDaOutra = this.creditoNoExtrato ? origem.rateiosDebito : origem.rateiosCredito;
              const semDaConta = this.creditoNoExtrato ? origem.semRateioCredito : origem.semRateioDebito;
              const semDaOutra = this.creditoNoExtrato ? origem.semRateioDebito : origem.semRateioCredito;

              itens.push({
                chave: 'extrato' + ix, valor: origem.valor, qtde: 1,
                rotulo: this.creditoNoExtrato ? 'Crédito' : 'Débito',
                cor: this.creditoNoExtrato ? 'cre' : 'deb',
                linha: this.nomeContaExtrato,
                nota: (this.ehSaldo ? 'Zera o saldo dos lançamentos selecionados · ' : 'Concilia a linha do extrato · ')
                    + this.notaRateio(rateioDaConta, semDaConta),
              });

              itens.push({
                chave: 'outra' + ix, valor: origem.valor, qtde: 1,
                rotulo: this.creditoNoExtrato ? 'Débito' : 'Crédito',
                cor: this.creditoNoExtrato ? 'deb' : 'cre',
                linha: nomeDaOrigem(origem),
                nota: this.notaRateio(rateioDaOutra, semDaOutra),
              });
            });

            if (this.form.gerarDebitoTransitoria && this.creditoNoExtrato) {
              itens.push({
                chave: 'tra-d', rotulo: 'Débito', cor: 'deb', valor, qtde: 1,
                linha: this.contaTransitoria,
                nota: this.rubricaDebito || 'Rubrica da configuração',
              });
              itens.push({
                chave: 'tra-c', rotulo: 'Crédito', cor: 'cre', valor, qtde: 1,
                linha: this.nomeContaExtrato,
                nota: this.rubricaCredito || 'Rubrica da configuração',
              });
            }
          }
        } else if (this.ehResgate) {
          itens.push({
            chave: 'c', rotulo: 'Crédito', cor: 'cre', valor, qtde: 1,
            linha: this.nomeContaExtrato,
            nota: 'Movimento na conta corrente · concilia a linha do extrato',
          });
          itens.push({
            chave: 'r', rotulo: 'Resgate', cor: 'deb', valor, qtde: 1,
            linha: this.aplicacaoEscolhida ? this.aplicacaoEscolhida.nomeTipoAplicacao : 'Aplicação de origem',
            nota: this.aplicacaoEscolhida ? this.aplicacaoEscolhida.nomeProjeto : 'Selecione a aplicação',
          });
        } else if (this.ehAplicacao) {
          itens.push({
            chave: 'd', rotulo: 'Débito', cor: 'deb', valor, qtde: 1,
            linha: this.nomeContaExtrato,
            nota: 'Movimento na conta corrente · concilia a linha do extrato',
          });
          itens.push({
            chave: 'a', rotulo: 'Aplicação', cor: 'cre', valor, qtde: 1,
            linha: this.aplicacaoEscolhida ? this.aplicacaoEscolhida.nomeTipoAplicacao : 'Aplicação de destino',
            nota: this.aplicacaoEscolhida ? this.aplicacaoEscolhida.nomeProjeto : 'Selecione a aplicação',
          });
        } else if (this.ehCreditoIdentificar) {
          itens.push({
            chave: 'c', rotulo: 'Crédito', cor: 'cre', valor, qtde: 1,
            linha: this.nomeContaExtrato,
            nota: (this.rubricaCredito ? this.rubricaCredito : 'Rubrica da configuração')
                + (projeto ? ' · ' + projeto : ''),
          });
          itens.push({
            chave: 'd', rotulo: 'Débito', cor: 'deb', valor, qtde: 1,
            linha: this.contaTransitoria,
            nota: (this.rubricaDebito ? this.rubricaDebito : 'Rubrica da configuração')
                + (projeto ? ' · ' + projeto : ''),
          });

          if (this.regExigeContaReceber)
            this.titulosRegCr.forEach((t, i) => {
              itens.push({
                chave: 'cr' + i, rotulo: this.variosCr ? 'Contas a receber ' + (i + 1) : 'Contas a receber',
                cor: 'azu', valor: this.valorRegCr(t), qtde: 1,
                linha: (t.tipoPessoa === 3 ? t.historico : t.nomeTerceiro) || 'Cliente do título',
                nota: (this.resumoRateio(t.rateios) || 'Projeto do título') + (t.notaFiscal ? ' · NF ' + t.notaFiscal.numero : ''),
              });
            });

          this.vinculadosEnvio.forEach(c => {
            itens.push({
              chave: 'vcr' + c.idLancamento, rotulo: 'Contas a receber ' + c.idLancamento, cor: 'cre', valor: c.valor, qtde: 0,
              vinculo: true,
              linha: c.nomePessoa || c.historico || 'Título existente',
              nota: +c.crOutraConta === 1
                ? 'Baixado na ' + this.contaTransitoria + ' quando a transferência concluir · sai de ' + (c.nomeConta || 'outra conta')
                : 'Baixado na ' + this.contaTransitoria + ' quando a transferência concluir',
            });
          });

          if (this.regExigeTransferencia) {
            this.reg.destinos.forEach((destino, ix) => {
              const linha = `${this.nomeContaOrigemReg} → ${destino.nomeConta || 'conta de destino'}`;

              if (this.viaSolicitacao)
                itens.push({
                  chave: 'solic' + ix, rotulo: 'Solicitação de transferência', cor: 'amb', valor: destino.valor, qtde: 0,
                  linha,
                  nota: 'Aguardando liberação. O lançamento é gerado quando ela for liberada.',
                });
              else
                itens.push({
                  chave: 'tr' + ix, rotulo: 'Transferência', cor: 'azu', valor: destino.valor, qtde: 2,
                  linha,
                  nota: 'Duas pernas lançadas agora',
                });
            });
          }
        }

        if (this.ehMovimento) {
          this.lancamentosMov.forEach((m, i) => {
            itens.push({
              chave: 'mv' + i, rotulo: this.creditoNoExtrato ? 'Crédito na conta' : 'Débito na conta',
              cor: this.creditoNoExtrato ? 'cre' : 'deb', valor: this.valorDoMov(m), qtde: 1,
              linha: this.resumoRateio(m.rateios) || 'Selecione o projeto',
              nota: m.rateios.length > 1 ? 'Rateado entre os projetos' : 'Rubrica e subrubrica do projeto',
            });
          });
        }

        if (this.ehContaReceberConta) {
          this.crc.titulos.forEach((t, i) => {
            itens.push({
              chave: 'cr' + t.chave, rotulo: t.notaFiscal ? 'Contas a receber · ' + t.notaFiscal.numero : 'Contas a receber',
              cor: 'cre', valor: this.valorDoTitulo(t), qtde: 1,
              linha: this.resumoRateio(t.rateios) || 'Selecione o projeto',
              nota: this.crc.baixarAgora ? 'Nasce baixado com este crédito' : 'Fica em aberto',
            });
          });
        }

        return itens;
      },
      totalLancamentos() { return this.previa.reduce((s, i) => s + i.qtde, 0); },
      conciliaAgora() {
        if (this.ehTransferencia) return !this.viaSolicitacao;
        if (this.ehContaReceberConta) return this.crc.baixarAgora;
        return this.ehResgate || this.ehAplicacao || this.ehCreditoIdentificar || this.ehMovimento;
      },
      resumoPrevia() {
        if (!this.operacao)
          return 'Escolha acima ' + (this.creditoNoExtrato ? 'de onde veio este crédito' : 'para onde foi este débito') + ' para ver o que será gerado.';
        if (this.ehSaldo && this.totalLancamentos === 0)
          return 'Nenhum lançamento agora, só a solicitação · os ' + this.deteccao.lancamentosSaldo.length
            + ' selecionados são conciliados agora.';
        if (this.totalLancamentos === 0)
          return 'Nenhum lançamento agora — só a solicitação, e a linha do extrato continua pendente.';

        const plural = this.totalLancamentos === 1 ? '1 lançamento' : this.totalLancamentos + ' lançamentos';
        if (this.ehSaldo && this.deteccao.boletos)
          return plural + ' ao confirmar · cada um dos ' + this.deteccao.lancamentosSaldo.length
            + ' selecionados é conciliado com o seu boleto do relatório.';
        if (this.ehSaldo)
          return plural + ' ao confirmar · conciliados com os ' + this.deteccao.lancamentosSaldo.length
            + ' selecionados.';
        return plural + ' ao confirmar · ' + (this.conciliaAgora
          ? 'o extrato é conciliado na hora.'
          : 'a linha do extrato continua pendente.');
      },
      gruposPrevia() {
        const decorar = i => Object.assign({}, i, { mk: this.marcador(i) });
        const grupos = [];
        const agora = this.previa.filter(i => i.qtde > 0).map(decorar);
        const depois = this.previa.filter(i => i.qtde === 0 && !i.vinculo).map(decorar);
        const vinculo = this.previa.filter(i => i.vinculo).map(decorar);

        if (agora.length) grupos.push({ chave: 'agora', titulo: 'Ao confirmar', itens: agora });
        if (depois.length) grupos.push({ chave: 'depois', titulo: 'Depois da liberação', itens: depois });
        if (vinculo.length) grupos.push({ chave: 'vinculo', titulo: 'Vinculados (baixa automática)', itens: vinculo });

        return grupos;
      },
      erros() {
        const e = {};

        if (this.ehTransferencia) {
          if (!this.origensValidas) e.origens = 'Complete as contas da transferência';
          if (this.viaSolicitacao) {
            if (!(this.form.idUsuarioLiberacao > 0)) e.liberador = 'Campo obrigatório';
            if (!this.observacaoPorConta && !(this.form.observacao || '').trim()) e.observacao = 'Campo obrigatório';
          }
        } else if (this.ehResgate || this.ehAplicacao) {
          if (!(this.form.idAplicacao > 0)) e.aplicacao = 'Selecione a aplicação';
        } else if (this.ehMovimento) {
          this.lancamentosMov.forEach((m, i) => {
            const prefixo = i === 0 ? 'mov' : 'movx' + i;
            Object.assign(e, this.errosLancamento(m, prefixo, true, this.valorDoMov(m)));
            if (m.devolucao && !this.devolucaoValida(m.devolucao, this.valorDoMov(m)))
              e[prefixo + 'Devolucao'] = 'Distribua o valor nas linhas da solicitação, sem passar do saldo, e informe no CI a quantidade dos itens controlados por quantidade';
            if (this.variosMovimentos && !(this.valorDoMov(m) > 0)) e[prefixo + 'Valor'] = 'Informe o valor';
          });
          if (this.variosMovimentos && Math.abs(this.faltaMovimentos) >= 0.005)
            e.movSoma = this.ehComplemento ? 'A soma dos lançamentos novos tem que ser igual à diferença' : 'A soma dos lançamentos tem que ser igual ao total';
        } else if (this.ehContaReceberConta) {
          this.crc.titulos.forEach((t, i) => {
            Object.assign(e, this.errosLancamento(t, 'crc' + i, false, this.valorDoTitulo(t)));
            if (this.variosTitulos && !(this.valorDoTitulo(t) > 0)) e['crc' + i + 'Valor'] = 'Informe o valor';
          });
          if (this.variosTitulos && Math.abs(this.faltaTitulos) >= 0.005)
            e.crcSoma = 'A soma dos títulos tem que ser igual ao crédito';
          if (!this.crc.dataVencimento) e.crcVencimento = 'Campo obrigatório';
        } else if (this.ehCreditoIdentificar) {
          if (this.regExigeTransferencia) {
            if (!this.destinosValidos) e.destinos = 'Complete as contas de destino';
            if (this.viaSolicitacao) {
              if (!(this.form.idUsuarioLiberacao > 0)) e.liberador = 'Campo obrigatório';
              if (!this.observacaoPorConta && !(this.form.observacao || '').trim()) e.observacao = 'Campo obrigatório';
            }
          }
          if (this.vinculadosEnvio.length
              && Math.abs(somaContasReceber(this.vinculadosEnvio) - this.deteccao.valor) >= 0.005)
            e.crVinculo = 'A soma dos contas a receber tem que ser igual ao valor';
          if (this.regExigeContaReceber) {
            const cr = this.reg.cr;
            if (!cr.tipoPessoa) e.crTipoPessoa = 'Escolha o tipo';
            if (cr.tipoPessoa > 0 && !this.semClienteRegCr && !(cr.idTerceiro > 0)) e.crCliente = 'Campo obrigatório';
            if (this.semClienteRegCr && !(cr.historico || '').trim()) e.crHistorico = 'Campo obrigatório';
            if (!(this.contaDoTituloCr > 0)) e.crConta = 'Campo obrigatório';
            if (this.categoriaObrigatoria && !(cr.idCategoriaFinanceira > 0)) e.crCategoria = 'Campo obrigatório';
            if (!this.semRateioCr && !this.rateioValido(cr.rateios, this.valorRegCr(cr))) e.crRateio = 'Complete o rateio';
            if (this.variosCr && !(this.valorRegCr(cr) > 0)) e.crValor = 'Informe o valor';

            this.crExtras.forEach((t, i) => {
              const p = 'crx' + (i + 1);
              if (!t.tipoPessoa) e[p + 'TipoPessoa'] = 'Escolha o tipo';
              if (t.tipoPessoa > 0 && t.tipoPessoa !== 3 && !(t.idTerceiro > 0)) e[p + 'Cliente'] = 'Campo obrigatório';
              if (t.tipoPessoa === 3 && !(t.historico || '').trim()) e[p + 'Historico'] = 'Campo obrigatório';
              if (this.categoriaObrigatoria && !(t.idCategoriaFinanceira > 0)) e[p + 'Categoria'] = 'Campo obrigatório';
              if (!this.semRateioCr && !this.rateioValido(t.rateios, this.valorRegCr(t))) e[p + 'Rateio'] = 'Complete o rateio';
              if (!(this.valorRegCr(t) > 0)) e[p + 'Valor'] = 'Informe o valor';
            });

            if (this.variosCr && Math.abs(this.faltaRegCr) >= 0.005)
              e.crSoma = 'A soma dos contas a receber tem que ser igual ao crédito';

            const notasCr = this.titulosRegCr.filter(t => t.notaFiscal).map(t => t.notaFiscal.idNotaFiscal);
            if (notasCr.some((n, i) => notasCr.indexOf(n) !== i)) e.crNotaRepetida = 'A mesma nota fiscal está em dois títulos';
          }
        }

        return e;
      },
      crNaTransitoria() {
        return !!this.configCredito && this.configCredito.idConta > 0 && this.contaDoTituloCr === this.configCredito.idConta;
      },
      contaDoTituloCr() {
        return this.reg.cr.idConta || (this.destinoPrincipal ? this.destinoPrincipal.idConta : 0) || 0;
      },
      valido() {
        return Object.keys(this.erros).length === 0
            && !(this.ehCreditoIdentificar && !this.configurado);
      },
      rotuloBotao() {
        if (this.ehComplemento) return 'Lançar e conciliar';
        if (this.pedeLiberacao && this.totalLancamentos === 0) return 'Criar solicitação';
        return 'Gerar lançamentos';
      },
    },
    watch: {
      chaveTaxaMov(chave) { this.carregarCheckTaxa(this.taxaMov, chave, () => this.chaveTaxaMov, () => !!this.mov.devolucao); },
      chavesTaxaCrc() {
        this.crc.titulos.forEach(t => {
          const chave = this.ehContaReceberConta && this.crc.baixarAgora ? this.chaveTaxa(t) : '';
          if (t.taxa.chave === chave) return;
          t.taxa.chave = chave;
          this.carregarCheckTaxa(t.taxa, chave, () => t.taxa.chave);
        });
      },
      chaveTaxaRegCr(chave) { this.carregarCheckTaxa(this.taxaRegCr, chave, () => this.chaveTaxaRegCr); },
      chavesTaxaCrExtras() {
        this.crExtras.forEach(t => {
          const chave = this.regExigeContaReceber ? this.chaveTaxa(t) : '';
          if (t.taxa.chave === chave) return;
          t.taxa.chave = chave;
          this.carregarCheckTaxa(t.taxa, chave, () => t.taxa.chave);
        });
      },
      'reg.destinos.length'() {
        if (this.ehCreditoIdentificar) this.sugerirObservacao();
      },
      chaveProjetosDestinos() {
        if (this.ehCreditoIdentificar) this.sugerirObservacao();
      },
      'form.origens.length'() {
        if (this.ehTransferencia) this.espalharObservacao();
      },
      operacao(valor) {
        if ((valor === 'resgate' || valor === 'aplicacao') && this.aplicacoes.length === 0)
          this.carregarAplicacoes();
        else if (valor === 'resgate' || valor === 'aplicacao')
          this.ajustarAplicacaoEscolhida();
        this.form.complemento = this.complementoPadrao(valor);
      },
    },
    mounted() {
      if (this.ehSaldo) this.viaSolicitacao = false;
      this.operacao = this.operacaoInicial();
      if (this.ehTarifaDoExtrato && this.deteccao.idCategoriaFinanceiraTarifa > 0) {
        this.mov.idCategoriaFinanceira = this.deteccao.idCategoriaFinanceiraTarifa;
        this.mov.nomeCategoriaFinanceira = this.deteccao.nomeCategoriaFinanceiraTarifa || '';
      }
      this.form.data = this.deteccao.data ? moment(this.deteccao.data, 'DD/MM/YYYY').toDate() : new Date();
      this.form.documento = this.deteccao.documentoTransferencia || '';
      this.form.complemento = this.complementoPadrao(this.operacao);
      this.form.idTipoAplicacao = this.deteccao.idTipoAplicacaoPadrao || 0;
      this.form.nomeTipoAplicacao = this.deteccao.nomeTipoAplicacaoPadrao || '';
      this.aplicacoes = this.deteccao.aplicacoes || [];

      this.reg.documento = '';
      this.reg.idContaOrigem = this.deteccao.idConta || 0;
      this.reg.nomeContaOrigem = this.deteccao.nomeConta || '';
      this.reg.cr.dataEmissao = new Date();
      this.reg.cr.dataVencimento = this.form.data;
      this.crc.dataEmissao = new Date();
      this.crc.dataVencimento = this.form.data;
      this.mov.formaPagamento = -1;

      this.ajustarAplicacaoEscolhida();

      this.montarTextosTransitoria(null);
      this.carregarConfiguracao();
      this.carregarConfigAnexos();
      this.carregarTextosPadrao();
      this.preencherClienteExtrato();
    },
    methods: {
      formatar(valor) {
        return (+valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      operacaoInicial() {
        const disponivel = v => this.operacoesDisponiveis.some(o => o.valor === v);
        if (this.ehComplemento) return 'movimento';
        if (this.deteccao.grupoTarifa || this.deteccao.operacaoIdentificada !== false)
          return disponivel(this.deteccao.operacao) ? this.deteccao.operacao : null;
        if (this.ehTarifaDoExtrato && disponivel('movimento')) return 'movimento';
        return null;
      },
      chaveProjetos(rateios) {
        return (rateios || []).filter(r => r.idProjeto > 0).map(r => r.idProjeto).join(',');
      },
      chaveTaxa(bloco) {
        const projetos = this.chaveProjetos(bloco.rateios);
        return projetos;
      },
      carregarCheckTaxa(alvo, chave, chaveAtual, semTaxa) {
        if (!chave) {
          alvo.mostrar = false;
          alvo.marcado = false;
          return;
        }

        conciliacaoProjetoServico.checkTaxa(this.idContaCript, { idsProjeto: chave.split(',').map(x => +x) })
          .then(r => {
            if (chaveAtual() !== chave) return;
            alvo.mostrar = !!(r && r.mostrar);
            alvo.marcado = !!(r && r.marcado) && !(semTaxa && semTaxa());
          })
          .catch(() => { alvo.mostrar = false; alvo.marcado = false; });
      },
      marcador(item) {
        if (item.cor === 'cre') return { texto: 'C' };
        if (item.cor === 'deb') return { texto: 'D' };
        if (item.cor === 'amb') return { icone: 'fa-clock-o' };
        return item.qtde === 2 ? { icone: 'fa-exchange' } : { texto: 'CR' };
      },
      moverAba(indice, passo) {
        const opcoes = this.operacoesDisponiveis;
        const destino = (indice + passo + opcoes.length) % opcoes.length;
        this.operacao = opcoes[destino].valor;
        this.$nextTick(() => {
          const abas = this.$refs.aba;
          if (abas && abas[destino]) abas[destino].focus();
        });
      },
      complementoPadrao(operacao) {
        return operacao === 'transferencia' ? (this.deteccao.complementoTransferencia || '') : '';
      },
      carregarTextosPadrao() {
        conciliacaoProjetoServico.textosPadrao()
          .then(dados => {
            this.textosDocumento = (dados && dados.documentos) || [];
            this.textosComplemento = (dados && dados.complementos) || [];
            this.textosHistorico = (dados && dados.historicos) || [];
          })
          .catch(() => {});
      },
      carregarConfiguracao() {
        this.carregandoConfig = true;
        conciliacaoProjetoServico.configuracaoCredito()
          .then(dados => {
            this.configCredito = dados || null;
            this.carregandoConfig = false;
            if (!this.reg.cr.idConta && dados && dados.idConta > 0) {
              this.reg.cr.idConta = dados.idConta;
              this.reg.cr.nomeConta = dados.nomeConta || '';
            }
            this.montarTextosTransitoria(dados);
          })
          .catch(() => { this.carregandoConfig = false; });
      },
      acharDocumentoNoHistorico(historico, documento) {
        const direto = historico.toUpperCase().indexOf(documento);
        if (direto >= 0) return { inicio: direto, fim: direto + documento.length };

        const mascarado = /[A-Za-z0-9]{2}\.[A-Za-z0-9]{3}\.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-\d{2}|\d{3}\.\d{3}\.\d{3}-\d{2}/g;
        let achado;

        while ((achado = mascarado.exec(historico)) !== null) {
          if (achado[0].replace(/[^A-Za-z0-9]/g, '').toUpperCase() === documento)
            return { inicio: achado.index, fim: achado.index + achado[0].length };
        }

        return null;
      },
      nomeDaContraparte(resto) {
        const partes = (resto || '').trim().split(/\s+/);
        const nome = [];

        for (const parte of partes) {
          if (/^\d+$/.test(parte)) break;
          nome.push(parte);
          if (nome.join(' ').length >= 30) break;
        }

        return nome.join(' ').slice(0, 30).trim();
      },
      contraparteDoExtrato() {
        const historico = this.deteccao.historico || '';
        const documento = (this.deteccao.cpfcnpj || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        const nomeGravado = (this.deteccao.nomeContraparte || '').trim();

        if (!documento) return nomeGravado ? { documento: '', nome: nomeGravado } : null;

        const posicao = historico ? this.acharDocumentoNoHistorico(historico, documento) : null;
        if (!posicao) return nomeGravado ? { documento, nome: nomeGravado } : null;

        return {
          documento: historico.slice(posicao.inicio, posicao.fim),
          nome: nomeGravado || this.nomeDaContraparte(historico.slice(posicao.fim)),
        };
      },
      montarTextosTransitoria(config) {
        if (this.deteccao.creditoDebito !== 1) return;

        const automatico = `${this.deteccao.prefixoTra || 'TRA'} - `;
        const inicioDocumento = (config && config.documento) || automatico;
        const inicioComplemento = (config && config.complemento) || automatico;
        const contraparte = this.contraparteDoExtrato();
        let documento = '';
        let complemento = '';

        if (contraparte) {
          documento = contraparte.nome || contraparte.documento;
          complemento = `${contraparte.documento} ${contraparte.nome}`.trim();
        } else if (!this.deteccao.cpfcnpj) {
          const historico = (this.deteccao.historico || '').replace(/\s+/g, ' ').trim();
          const continuacao = continuacaoDoHistorico(historico);
          if (/[A-Za-z]/.test(continuacao)) {
            documento = continuacao;
            complemento = continuacao;
          } else {
            documento = nomeDoHistorico(historico) || continuacao || historico;
            complemento = historico;
          }
        }

        this.reg.documento = (inicioDocumento + documento).slice(0, 20);
        this.reg.complemento = (inicioComplemento + complemento).slice(0, 300);
      },
      preencherClienteExtrato() {
        const normalizar = v => (v || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        const doc = normalizar(this.deteccao.cpfcnpj);
        if (!doc || this.deteccao.contraparteFundacao) return;
        const tipo = doc.length === 11 ? 1 : doc.length === 14 ? 2 : 0;
        conciliacaoProjetoServico.pessoasCredito(doc)
          .then(pessoas => {
            const exatas = (pessoas || []).filter(p => normalizar(p.complemento) === doc);
            if (exatas.length !== 1) return;
            const pessoa = exatas[0];
            if (!tipo) return;
            [this.mov, this.crc.titulos[0], this.reg.cr].forEach(bloco => {
              if (bloco.tipoPessoa !== 0) return;
              bloco.tipoPessoa = tipo;
              bloco.idTerceiro = pessoa.id;
              bloco.nomeTerceiro = pessoa.nome;
            });
          })
          .catch(() => {});
      },
      notaRateio(rateios, semProjetos) {
        const linhas = rateios || [];

        if (semProjetos) return 'Conta sem projeto · sem rateio';
        if (linhas.length === 0) return 'Sem rateio';

        const completas = linhas.filter(r => r.idProjeto > 0);

        if (completas.length === 0) return 'Rateio em branco — complete ou remova as linhas';
        if (completas.length < linhas.length) return completas.length + ' de ' + linhas.length + ' linhas do rateio preenchidas';
        if (completas.length === 1) {
          const r = completas[0];
          return r.nomeProjeto + (r.nomeRubrica ? ' · ' + r.nomeRubrica : '');
        }

        return 'Rateado entre ' + completas.length + ' projetos';
      },
      resumoRateio(rateios) {
        const preenchidos = (rateios || []).filter(r => r.idProjeto > 0);

        if (preenchidos.length === 0) return '';
        if (preenchidos.length === 1) return preenchidos[0].nomeProjeto;

        return preenchidos.length + ' projetos no rateio';
      },
      rateioValido(rateios, total, comItem = false) {
        if (!rateios || rateios.length === 0) return false;
        if (rateios.some(r => !(r.idProjeto > 0) || !(r.idRubrica > 0) || !(r.idSubRubrica > 0))) return false;
        if (comItem && rateios.some(r => r.exigeItem && !(r.idItem > 0))) return false;
        if (rateios.some(r => !((+r.valor || 0) > 0))) return false;

        const chaves = rateios.map(r => r.idProjeto + '-' + r.idRubrica + '-' + r.idSubRubrica +
                                        '-' + (comItem ? (r.idItem || 0) : 0));
        if (chaves.some((c, i) => chaves.indexOf(c) !== i)) return false;

        const soma = rateios.reduce((s, r) => s + (+r.valor || 0), 0);

        return Math.abs(Math.round((soma - total) * 100) / 100) < 0.005;
      },
      origensParaEnvio() {
        return this.form.origens.map(origem => ({
          idContaContraria: origem.idConta,
          valor: origem.valor,
          observacao: this.observacaoDaConta(origem),
          rateiosDebito: this.rateioParaEnvio(origem.rateiosDebito, !this.viaSolicitacao),
          rateiosCredito: this.rateioParaEnvio(origem.rateiosCredito, !this.viaSolicitacao),
        }));
      },
      destinosParaEnvio() {
        return this.reg.destinos.map(destino => ({
          idContaDestino: destino.idConta,
          valor: destino.valor,
          observacao: this.observacaoDaConta(destino),
        }));
      },
      observacaoDaConta(conta) {
        return this.observacaoPorConta ? (conta.observacao || '') : (this.form.observacao || '');
      },
      espalharObservacao() {
        if (!this.observacaoPorConta) return;

        const texto = (this.form.observacao || '').trim();

        if (!texto) return;

        this.contasDaSolicitacao.forEach(conta => {
          if (!(conta.observacao || '').trim()) this.$set(conta, 'observacao', texto);
        });
      },
      rateioParaEnvio(rateios, comItem = false) {
        return (rateios || []).map(r => ({
          idProjeto: r.idProjeto,
          idRubrica: r.idRubrica,
          idSubRubrica: r.idSubRubrica,
          valor: +r.valor || 0,
          idProjetoItemControle: comItem ? (r.idItem || 0) : 0,
          quantidade: comItem ? (+r.quantidade || 0) : 0,
        }));
      },
      errosLancamento(bloco, prefixo, comItem = false, total = this.deteccao.valor) {
        const e = {};
        const semCliente = bloco.tipoPessoa === 3;

        if (!bloco.tipoPessoa) e[prefixo + 'TipoPessoa'] = 'Escolha o tipo';
        if (bloco.tipoPessoa > 0 && !semCliente && !(bloco.idTerceiro > 0)) e[prefixo + 'Cliente'] = 'Campo obrigatório';
        if (semCliente && !(bloco.historico || '').trim()) e[prefixo + 'Historico'] = 'Campo obrigatório';
        if (this.categoriaObrigatoria && !(bloco.idCategoriaFinanceira > 0))
          e[prefixo + 'Categoria'] = 'Campo obrigatório';
        if (!this.semRateioConta && !this.rateioValido(bloco.rateios, total, comItem))
          e[prefixo + 'Rateio'] = 'Complete o rateio';

        return e;
      },
      escolherContaCorrente(bloco) {
        if (bloco.tipoPessoa === 4) return;

        bloco.tipoPessoa = 4;
        bloco.idTerceiro = 0;
        bloco.nomeTerceiro = '';
        bloco.notaFiscal = null;
        if (bloco.devolucao) this.devolucaoDoMov(bloco, null);
        bloco.historico = '';
      },
      contaCorrenteEscolhida(bloco, opcao) {
        bloco.nomeTerceiro = opcao ? opcao.nome : '';
      },
      escolherTipoPessoaBloco(bloco, tipo) {
        if (bloco.tipoPessoa === tipo) return;

        bloco.tipoPessoa = tipo;
        bloco.idTerceiro = 0;
        bloco.nomeTerceiro = '';
        bloco.notaFiscal = null;

        if (tipo > 0) bloco.historico = '';
      },
      devolucaoValida(devolucao, total) {
        const linhas = (devolucao && devolucao.linhas) || [];
        if (linhas.some(l => (+l.valor || 0) > (+l.saldo || 0) + 0.005)) return false;
        if (linhas.some(l => l.exigeQuantidade && (+l.valor || 0) > 0 && !((+l.quantidade || 0) > 0))) return false;
        const soma = linhas.reduce((s, l) => s + (+l.valor || 0), 0);
        return soma > 0 && Math.abs(Math.round((soma - total) * 100) / 100) < 0.005;
      },
      devolucaoDoMov(bloco, devolucao) {
        const chave = d => (d ? (d.tipoSolicitacao || 'SP') + '-' + d.idSolicitacao : '');
        const anterior = chave(bloco.devolucao);
        const atual = chave(devolucao);
        bloco.devolucao = devolucao;
        if (atual && atual !== anterior) {
          if (bloco === this.mov) this.taxaMov.marcado = false;
          if (!bloco.idTerceiro && devolucao.idPessoa > 0 && (devolucao.tipoPessoa === 1 || devolucao.tipoPessoa === 2)) {
            bloco.tipoPessoa = devolucao.tipoPessoa;
            bloco.idTerceiro = devolucao.idPessoa;
            bloco.nomeTerceiro = devolucao.nomePessoa;
          }
        }
        bloco.rateios = !devolucao ? [] : devolucao.linhas
          .filter(l => (+l.valor || 0) > 0)
          .map(l => ({
            idProjeto: l.idProjeto, nomeProjeto: l.nomeProjeto,
            idRubrica: l.idRubrica, nomeRubrica: l.nomeRubrica,
            idSubRubrica: l.idSubRubrica, nomeSubrubrica: l.nomeSubrubrica,
            idItem: l.idProjetoItemControle || 0, nomeItem: l.nomeItem || '', exigeItem: false,
            quantidade: +l.quantidade || 0, quantidadeTexto: l.quantidadeTexto || '0',
            valor: +l.valor || 0, valorTexto: l.valorTexto || '',
          }));
      },
      textosDevolucao(bloco, complemento) {
        const d = bloco.devolucao;
        if (!d || !d.idSolicitacao) return [];
        const sigla = d.tipoSolicitacao || 'SP';
        const fim = new RegExp('\\b' + sigla + '\\.?$', 'i');
        const cadastrados = (complemento ? this.textosComplemento : this.textosDocumento)
          .map(t => (t || '').trim())
          .filter(t => fim.test(t));
        const prefixos = cadastrados.length ? cadastrados : ['DEVOL. REF. ' + sigla];
        const contraparte = this.contraparteDoExtrato();
        const nomes = complemento
          ? [(contraparte && contraparte.nome) || nomeDoHistorico(this.deteccao.historico), d.nomePessoa]
              .map(t => (t || '').trim()).filter(t => !!t)
          : [];
        const limite = complemento ? 300 : 50;
        const textos = [];
        prefixos.forEach(p => {
          const base = p + ' ' + d.idSolicitacao;
          textos.push(base.slice(0, limite));
          nomes.forEach(nome => textos.push((base + ' - ' + nome).slice(0, limite)));
        });
        return textos.filter((t, i) => textos.indexOf(t) === i);
      },
      idsProjetoDe(rateios) {
        return (rateios || []).map(r => +r.idProjeto || 0).filter(id => id > 0);
      },
      clienteDaNotaFiscal(bloco, cliente) {
        if (cliente.tipoPessoa) bloco.tipoPessoa = cliente.tipoPessoa;
        bloco.idTerceiro = cliente.idPessoa;
        bloco.nomeTerceiro = cliente.nomePessoa;
      },
      valorDoMov(lancamento) {
        if (!this.variosMovimentos) return +this.deteccao.valor || 0;
        return Math.round((+lancamento.valor || 0) * 100) / 100;
      },
      adicionarMovimento() {
        const novo = novoTituloCr();
        const falta = this.faltaMovimentos;
        if (!this.variosMovimentos && !(this.mov.valor > 0)) {
          this.mov.valor = +this.deteccao.valor || 0;
          this.mov.valorTexto = this.formatar(this.mov.valor);
        }
        novo.valor = falta > 0 && this.variosMovimentos ? falta : 0;
        novo.valorTexto = novo.valor > 0 ? this.formatar(novo.valor) : '';
        novo.idCategoriaFinanceira = this.mov.idCategoriaFinanceira;
        novo.nomeCategoriaFinanceira = this.mov.nomeCategoriaFinanceira;
        this.movExtras.push(novo);
      },
      valorRegCr(titulo) {
        if (!this.variosCr) return +this.deteccao.valor || 0;
        return Math.round((+titulo.valor || 0) * 100) / 100;
      },
      adicionarCr() {
        const novo = novoTituloCr();
        const cr = this.reg.cr;
        if (!this.variosCr && !(cr.valor > 0)) {
          cr.valor = +this.deteccao.valor || 0;
          cr.valorTexto = this.formatar(cr.valor);
        }
        const falta = this.variosCr ? this.faltaRegCr : 0;
        novo.valor = falta > 0 ? falta : 0;
        novo.valorTexto = novo.valor > 0 ? this.formatar(novo.valor) : '';
        novo.idCategoriaFinanceira = cr.idCategoriaFinanceira;
        novo.nomeCategoriaFinanceira = cr.nomeCategoriaFinanceira;
        novo.dataEmissao = cr.dataEmissao;
        novo.dataVencimento = cr.dataVencimento;
        this.crExtras.push(novo);
      },
      removerCr(indice) {
        this.crExtras.splice(indice, 1);
      },
      crComErro(indice) {
        if (!this.validar) return false;
        if (indice === 0) return Object.keys(this.erros).some(k => /^cr[A-Z]/.test(k) && k !== 'crSoma' && k !== 'crNotaRepetida' && k !== 'crVinculo');
        const padrao = new RegExp('^crx' + indice + '[A-Z]');
        return Object.keys(this.erros).some(k => padrao.test(k));
      },
      removerMovimento(indice) {
        this.movExtras.splice(indice, 1);
        if (!this.variosMovimentos) {
          this.mov.valor = 0;
          this.mov.valorTexto = '';
        }
      },
      valorDoTitulo(titulo) {
        if (!this.variosTitulos) return +this.deteccao.valor || 0;
        return Math.round((+titulo.valor || 0) * 100) / 100;
      },
      digitarValorTitulo(titulo, evento) {
        titulo.valorTexto = evento.target.value;
        const numero = +(evento.target.value || '').replace(/\./g, '').replace(',', '.');
        titulo.valor = isNaN(numero) ? 0 : numero;
      },
      usarFalta(bloco, falta) {
        const valor = Math.round(((+bloco.valor || 0) + falta) * 100) / 100;
        bloco.valor = valor > 0 ? valor : 0;
        bloco.valorTexto = bloco.valor > 0 ? this.formatar(bloco.valor) : '';
      },
      sairValorTitulo(titulo) {
        titulo.valorTexto = titulo.valor > 0 ? this.formatar(titulo.valor) : '';
      },
      sairValorMov(bloco) {
        this.sairValorTitulo(bloco);
        if (!this.variosMovimentos) return;
        const lista = this.lancamentosMov;
        const indice = lista.indexOf(bloco);
        const alvo = lista[indice + 1] || lista[indice - 1];
        if (!alvo) return;
        const outros = lista.filter(m => m !== alvo).reduce((s, m) => s + (+m.valor || 0), 0);
        const resto = Math.round(((+this.deteccao.valor || 0) - outros) * 100) / 100;
        if (resto < 0 || Math.abs(resto - (+alvo.valor || 0)) < 0.005) return;
        alvo.valor = resto;
        alvo.valorTexto = resto > 0 ? this.formatar(resto) : '';
      },
      adicionarTitulo() {
        const novo = novoTituloCr();
        const falta = this.faltaTitulos;
        if (!this.variosTitulos) {
          const primeiro = this.crc.titulos[0];
          if (!(primeiro.valor > 0)) {
            primeiro.valor = +this.deteccao.valor || 0;
            primeiro.valorTexto = this.formatar(primeiro.valor);
          }
        }
        novo.valor = falta > 0 && this.variosTitulos ? falta : 0;
        novo.valorTexto = novo.valor > 0 ? this.formatar(novo.valor) : '';
        novo.idCategoriaFinanceira = this.crc.titulos[0].idCategoriaFinanceira;
        novo.nomeCategoriaFinanceira = this.crc.titulos[0].nomeCategoriaFinanceira;
        this.crc.titulos.push(novo);
      },
      removerTitulo(indice) {
        this.crc.titulos.splice(indice, 1);
        if (this.crc.titulos.length === 0) this.crc.titulos.push(novoTituloCr());
      },
      escolherCategoriaTitulo(titulo, opcao) {
        titulo.nomeCategoriaFinanceira = opcao ? opcao.nome : '';
        if (!opcao) return;
        this.crc.titulos.forEach(t => {
          if (t !== titulo && !(t.idCategoriaFinanceira > 0)) {
            t.idCategoriaFinanceira = titulo.idCategoriaFinanceira;
            t.nomeCategoriaFinanceira = titulo.nomeCategoriaFinanceira;
          }
        });
      },
      tituloVazio(titulo) {
        return !titulo.notaFiscal && !(titulo.rateios || []).some(r => r.idProjeto > 0)
            && !(titulo.documento || '').trim() && !(titulo.complemento || '').trim();
      },
      textosDaNotaFiscal(titulo, nf) {
        if (!(titulo.documento || '').trim() && nf.numero) titulo.documento = String(nf.numero).slice(0, 30);
        if (!(titulo.complemento || '').trim() && nf.complemento) titulo.complemento = String(nf.complemento).slice(0, 300);
      },
      tituloDaNotaFiscal(nf) {
        const titulo = novoTituloCr();
        const documento = (nf.cpfcnpj || '').replace(/[^A-Za-z0-9]/g, '');
        if (nf.idPessoa > 0) {
          titulo.tipoPessoa = documento.length === 11 ? 1 : 2;
          titulo.idTerceiro = nf.idPessoa;
          titulo.nomeTerceiro = nf.nomePessoa || '';
        }
        titulo.notaFiscal = nf;
        titulo.valor = Math.round((+nf.valor || 0) * 100) / 100;
        titulo.valorTexto = this.formatar(titulo.valor);
        titulo.rateios = this.linhasDoRateioNf(nf.rateios);
        this.textosDaNotaFiscal(titulo, nf);
        return titulo;
      },
      notasEscolhidas(notas) {
        const ids = notas.map(n => n.idNotaFiscal);
        const mantidos = this.crc.titulos.filter(t => !this.tituloVazio(t)
          && (!t.notaFiscal || ids.indexOf(t.notaFiscal.idNotaFiscal) >= 0));
        const jaTem = mantidos.filter(t => t.notaFiscal).map(t => t.notaFiscal.idNotaFiscal);
        const novos = notas.filter(n => jaTem.indexOf(n.idNotaFiscal) < 0).map(n => this.tituloDaNotaFiscal(n));
        const categoria = this.crc.titulos.filter(t => t.idCategoriaFinanceira > 0)[0];

        if (categoria)
          novos.forEach(t => {
            t.idCategoriaFinanceira = categoria.idCategoriaFinanceira;
            t.nomeCategoriaFinanceira = categoria.nomeCategoriaFinanceira;
          });

        const titulos = mantidos.concat(novos);
        this.crc.titulos = titulos.length ? titulos : [novoTituloCr()];

        if (this.crc.titulos.length === 1) {
          const unico = this.crc.titulos[0];
          unico.valor = +this.deteccao.valor || 0;
          unico.valorTexto = this.formatar(unico.valor);
        }
      },
      notaFiscalDoTitulo(titulo, nf) {
        titulo.notaFiscal = nf;
        if (!nf) return;
        if (this.variosTitulos && !(titulo.valor > 0)) {
          titulo.valor = Math.round((+nf.valor || 0) * 100) / 100;
          titulo.valorTexto = this.formatar(titulo.valor);
        }
        this.textosDaNotaFiscal(titulo, nf);
      },
      avisoPagador(titulo) {
        if (!titulo.notaFiscal || this.deteccao.contraparteFundacao) return '';
        const normalizar = v => (v || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        const doExtrato = normalizar(this.deteccao.cpfcnpj);
        const daNota = normalizar(titulo.notaFiscal.cpfcnpj);
        if (!doExtrato || !daNota || doExtrato === daNota) return '';
        if (doExtrato.length === 14 && daNota.length === 14 && doExtrato.slice(0, 8) === daNota.slice(0, 8))
          return 'A NF é de outra unidade do mesmo grupo (' + this.formatarDocumento(daNota)
               + '); o crédito veio de ' + this.formatarDocumento(doExtrato) + '.';
        return 'O crédito veio de ' + this.formatarDocumento(doExtrato) + ', mas a NF é de '
             + this.formatarDocumento(daNota) + '.';
      },
      formatarDocumento(d) {
        if (d.length === 14) return d.slice(0, 2) + '.' + d.slice(2, 5) + '.' + d.slice(5, 8) + '/' + d.slice(8, 12) + '-' + d.slice(12);
        if (d.length === 11) return d.slice(0, 3) + '.' + d.slice(3, 6) + '.' + d.slice(6, 9) + '-' + d.slice(9);
        return d;
      },
      linhasDoRateioNf(rateios) {
        const formatar = v => v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return (rateios || []).filter(r => +r.idProjeto > 0).map(r => ({
          idProjeto: r.idProjeto, nomeProjeto: r.nomeProjeto || '',
          idRubrica: +r.idRubrica || 0, nomeRubrica: r.nomeRubrica || '',
          idSubRubrica: +r.idSubRubrica || 0, nomeSubrubrica: r.nomeSubrubrica || '',
          idItem: 0, nomeItem: '', exigeItem: false,
          quantidade: 1, quantidadeTexto: '1',
          valor: Math.round((+r.valor || 0) * 100) / 100,
          valorTexto: formatar(Math.round((+r.valor || 0) * 100) / 100),
        }));
      },
      rateioDaNotaFiscal(bloco, rateios, comItem = false) {
        const linhas = this.linhasDoRateioNf(rateios);
        if (!linhas.length) return;

        const aplicar = () => {
          bloco.rateios = linhas;
          if (comItem) linhas.forEach(l => this.verificarItemDaLinha(l));
        };

        if (!(bloco.rateios || []).some(r => r.idProjeto > 0)) {
          aplicar();
          return;
        }

        this.$swal({
          title: 'Rateio da nota fiscal',
          text: 'A NF tem rateio por projeto. Deseja trocar o rateio já informado pelo da nota?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, usar o da NF',
          cancelButtonText: 'Manter o atual',
        })
          .then(result => { if (result === true || (result && result.value)) aplicar(); })
          .catch(() => {});
      },
      verificarItemDaLinha(linha) {
        if (!linha.idSubRubrica) return;

        conciliacaoProjetoServico
          .itensControle(this.idContaCript, linha.idProjeto, linha.idRubrica, linha.idSubRubrica, '')
          .then(resposta => {
            const itens = (resposta && resposta.itens) || [];
            linha.exigeItem = !!(resposta && resposta.exigeItem);
            if (linha.exigeItem && itens.length === 1) {
              linha.idItem = itens[0].id;
              linha.nomeItem = itens[0].nome;
            }
          })
          .catch(() => { linha.exigeItem = false; });
      },
      idNotaFiscalDe(bloco, semCliente) {
        return !semCliente && bloco.notaFiscal ? bloco.notaFiscal.idNotaFiscal : 0;
      },
      buscarPessoasMov(termo) { return conciliacaoProjetoServico.pessoasCredito(termo, this.mov.tipoPessoa); },
      buscarPessoasTitulo(titulo) { return termo => conciliacaoProjetoServico.pessoasCredito(termo, titulo.tipoPessoa); },
      buscarPessoasRegCr(termo) { return conciliacaoProjetoServico.pessoasCredito(termo, this.reg.cr.tipoPessoa); },
      buscarCategorias(termo) { return conciliacaoProjetoServico.categoriasFinanceiras(termo); },
      buscarContas(termo) { return conciliacaoProjetoServico.contasOperacao(this.idContaCript, termo); },
      buscarProjetos(termo) { return conciliacaoProjetoServico.projetosCredito(termo); },
      buscarUsuarios(termo) { return conciliacaoProjetoServico.usuariosLiberacao(termo); },
      buscarPessoas(termo) { return conciliacaoProjetoServico.pessoasCredito(termo); },
      buscarContasGerais(termo) { return conciliacaoProjetoServico.contasGerais(termo, true); },
      preencherUnico(...refs) {
        this.$nextTick(() => {
          refs.forEach(nome => {
            const campo = this.$refs[nome];
            if (campo && campo.preencherSeUnico) campo.preencherSeUnico();
          });
        });
      },
      aoEscolherContaDestino(evento) {
        const opcao = evento ? evento.opcao : null;
        const primeiro = evento ? evento.indice === 0 : false;

        if (opcao && primeiro && !this.reg.cr.idConta) {
          this.reg.cr.idConta = opcao.id;
          this.reg.cr.nomeConta = opcao.nome;
        }

        this.sugerirObservacao();
      },
      numeroDaConta(nome) {
        const partes = (nome || '').split(' - C/C ');
        return (partes.length > 1 ? partes[partes.length - 1] : partes[0]).trim();
      },
      trechoConta(nome, codigo) {
        const conta = `CC ${this.numeroDaConta(nome)}`;
        if (codigo === '()') return `${conta} ()`;
        return codigo ?`${conta} (${codigo.split(', ').map(c => 'P.' + c).join(', ')})` : conta;
      },
      textoObservacao(origem, trechosDestino) {
        return `CRED. RECEBIDO INDEVIDAMENTE NA ${origem}. SOLICITO TRANSF. PARA ${trechosDestino.join(' E ')}`.slice(0, 300);
      },
      montarObservacao(contas, origens, trechosDestino) {
        if (!trechosDestino.length) return;

        if (!this.observacaoPorConta) {
          const texto = this.textoObservacao(origens[0], trechosDestino);
          const atual = (this.form.observacao || '').trim();

          if (!atual || this.form.observacao === this.observacaoSugerida) this.form.observacao = texto;

          this.observacaoSugerida = texto;
          return;
        }

        contas.forEach((conta, indice) => {
          const texto = this.textoObservacao(origens[indice], [trechosDestino[indice]]);
          const atual = (conta.observacao || '').trim();

          if (!atual || conta.observacao === conta.observacaoSugerida) this.$set(conta, 'observacao', texto);

          this.$set(conta, 'observacaoSugerida', texto);
        });
      },
      sugerirObservacao() {
        const contas = this.destinosEscolhidos;

        if (contas.length === 0) return;

        const projetos = rateios => (rateios || []).filter(r => r.idProjeto > 0).map(r => r.idProjeto);
        const codigo = (idConta, ids) => conciliacaoProjetoServico.codigoProjetoConta(this.idContaCript, idConta, ids).catch(() => '');
        const origem = ids => codigo(this.deteccao.idConta, ids).then(c => this.trechoConta(this.deteccao.nomeConta, c));
        const pedido = ++this.pedidoObservacao;

        const origens = this.observacaoPorConta
          ? Promise.all(contas.map(conta => origem(projetos(conta.rateiosDebito))))
          : origem([].concat(...contas.map(conta => projetos(conta.rateiosDebito)))).then(trecho => [trecho]);

        const destinos = Promise.all(contas.map(conta =>
          codigo(conta.idConta, projetos(conta.rateiosCredito).concat(this.projetosRateioCr))
            .then(c => this.trechoConta(conta.nomeConta, c))));

        Promise.all([origens, destinos]).then(([trechosOrigem, trechosDestino]) => {
          if (pedido !== this.pedidoObservacao) return;
          this.montarObservacao(contas, trechosOrigem, trechosDestino);
        });
      },
      carregarAplicacoes() {
        this.carregandoAplicacoes = true;
        conciliacaoProjetoServico.aplicacoesConta(this.idContaCript, '')
          .then(lista => {
            this.aplicacoes = lista || [];
            this.carregandoAplicacoes = false;
            this.ajustarAplicacaoEscolhida();
          })
          .catch(() => {
            this.carregandoAplicacoes = false;
            toastr.error('Não foi possível carregar as aplicações da conta.');
          });
      },
      ajustarAplicacaoEscolhida() {
        const lista = this.aplicacoesDaOperacao;
        if (!lista.some(a => a.idAplicacao === this.form.idAplicacao)) this.form.idAplicacao = 0;
        if (lista.length === 1) this.escolherAplicacao(lista[0]);
      },
      escolherAplicacao(aplicacao) {
        this.form.idAplicacao = aplicacao.idAplicacao;
        this.form.idProjeto = aplicacao.idProjeto;
        this.form.nomeProjeto = aplicacao.nomeProjeto;
        this.form.idTipoAplicacao = aplicacao.idTipoAplicacao;
        this.form.nomeTipoAplicacao = aplicacao.nomeTipoAplicacao;
      },
      dataTexto(data) {
        const alvo = data || this.form.data;
        return alvo ? moment(alvo).format('YYYY-MM-DD') : '';
      },
      chamadaConfirmacao() {
        if (this.ehCreditoIdentificar) {
          const payload = {
            tipo: this.reg.tipo,
            idExtrato: this.deteccao.idExtrato,
            idsExtrato: this.idsExtratoEnvio,
            valor: this.deteccao.valor,
            dataCredito: this.dataTexto(),
            documento: this.reg.documento || '',
            complemento: this.reg.complemento || '',
            idContaDestino: this.regExigeTransferencia && this.destinoPrincipal ? this.destinoPrincipal.idConta : 0,
            idContaOrigemTransferencia: this.regExigeTransferencia && this.origemRegAlterada ? this.reg.idContaOrigem : 0,
            destinos: this.regExigeTransferencia ? this.destinosParaEnvio() : [],
            dataTransferencia: this.regExigeTransferencia ? this.dataTexto() : '',
            documentoTransferencia: this.reg.documento || '',
            complementoTransferencia: this.reg.complemento || '',
            transferenciaViaSolicitacao: this.regExigeTransferencia && this.viaSolicitacao,
            idUsuarioLiberacao: this.form.idUsuarioLiberacao || 0,
            observacaoSolicitacao: this.form.observacao || '',
            contaReceber: null,
            idsContaReceber: this.vinculadosEnvio.map(c => c.idLancamento),
          };

          if (this.regExigeContaReceber) {
            payload.contasReceber = this.titulosRegCr.map((cr, i) => {
              const semCliente = cr.tipoPessoa === 3;
              const taxa = i === 0 ? this.taxaRegCr : cr.taxa;
              return {
                rateios: this.rateioParaEnvio(cr.rateios),
                idConta: this.contaDoTituloCr,
                idTerceiro: semCliente ? 0 : cr.idTerceiro,
                idCategoriaFinanceira: cr.idCategoriaFinanceira,
                dataEmissao: this.dataTexto(cr.dataEmissao),
                dataVencimento: this.dataTexto(cr.dataVencimento),
                documento: cr.documento || '',
                historico: semCliente ? (cr.historico || '').trim() : (cr.nomeTerceiro || ''),
                complemento: cr.complemento || '',
                valor: this.valorRegCr(cr),
                comTaxa: taxa.mostrar && taxa.marcado,
                idNotaFiscal: this.idNotaFiscalDe(cr, semCliente),
              };
            });
            payload.contaReceber = payload.contasReceber[0];
          }

          return conciliacaoProjetoServico.regularizarCredito(this.idContaCript, payload);
        }

        if (this.ehMovimento) {
          const comTaxa = this.creditoNoExtrato && this.taxaMov.mostrar && this.taxaMov.marcado;

          return conciliacaoProjetoServico.lancarMovimento(this.idContaCript, {
            idExtrato: this.deteccao.idExtrato,
            idsExtrato: this.idsExtratoEnvio,
            data: this.dataTexto(),
            formaPagamento: this.mov.formaPagamento,
            lancamentos: this.lancamentosMov.map((m, i) => {
              const semCliente = m.tipoPessoa === 3;
              const contaCorrente = m.tipoPessoa === 4;
              return {
                tipoCadastro: contaCorrente ? 3 : 0,
                idTerceiro: semCliente ? 0 : m.idTerceiro,
                historico: semCliente ? (m.historico || '').trim() : '',
                rateios: this.rateioParaEnvio(m.rateios, true),
                idCategoriaFinanceira: m.idCategoriaFinanceira,
                documento: m.documento || '',
                complemento: m.complemento || '',
                valor: this.valorDoMov(m),
                comTaxa: comTaxa && !m.devolucao,
                idNotaFiscal: this.creditoNoExtrato && !contaCorrente && !m.devolucao ? this.idNotaFiscalDe(m, semCliente) : 0,
                idSolicitacaoDevolvida: this.creditoNoExtrato && !contaCorrente && m.devolucao ? m.devolucao.idSolicitacao : 0,
                tipoSolicitacaoDevolvida: m.devolucao ? (m.devolucao.tipoSolicitacao || 'SP') : '',
              };
            }),
            idsLancamentoExistente: this.ehComplemento ? this.deteccao.complemento.lancamentos.map(l => l.idLancamento) : [],
            diferenca: this.ehComplemento ? this.deteccao.complemento.diferenca : 0,
          });
        }

        if (this.ehContaReceberConta) {
          return conciliacaoProjetoServico.lancarContaReceberConta(this.idContaCript, {
            idExtrato: this.deteccao.idExtrato,
            idsExtrato: this.idsExtratoEnvio,
            dataEmissao: this.dataTexto(this.crc.dataEmissao),
            dataVencimento: this.dataTexto(this.crc.dataVencimento),
            dataBaixa: this.dataTexto(),
            baixarAgora: this.crc.baixarAgora,
            titulos: this.crc.titulos.map(t => {
              const semCliente = t.tipoPessoa === 3;
              return {
                idTerceiro: semCliente ? 0 : t.idTerceiro,
                historico: semCliente ? (t.historico || '').trim() : '',
                rateios: this.rateioParaEnvio(t.rateios),
                idCategoriaFinanceira: t.idCategoriaFinanceira,
                documento: t.documento || '',
                complemento: t.complemento || '',
                valor: this.valorDoTitulo(t),
                comTaxa: this.crc.baixarAgora && t.taxa.mostrar && t.taxa.marcado,
                idNotaFiscal: this.idNotaFiscalDe(t, semCliente),
              };
            }),
          });
        }

        if (this.ehTransferencia && this.viaSolicitacao)
          return conciliacaoProjetoServico.solicitarTransferencia(this.idContaCript, {
            idExtrato: this.deteccao.idExtrato,
            idsExtrato: this.idsExtratoEnvio,
            idUsuarioLiberacao: this.form.idUsuarioLiberacao,
            data: this.dataTexto(),
            documento: this.form.documento,
            complemento: this.form.complemento,
            observacao: this.form.observacao,
            origens: this.origensParaEnvio(),
          });

        if (this.ehSaldo)
          return conciliacaoProjetoServico.transferirSaldo(this.idContaCript, {
            idsLancamento: this.deteccao.lancamentosSaldo.map(l => l.idLancamento),
            idsExtrato: this.deteccao.idsExtratoSaldo || [],
            data: this.dataTexto(),
            documento: this.form.documento,
            complemento: this.form.complemento,
            justificativa: (this.form.justificativa || '').trim(),
            viaSolicitacao: this.viaSolicitacao,
            idUsuarioLiberacao: this.viaSolicitacao ? this.form.idUsuarioLiberacao : 0,
            observacao: this.viaSolicitacao ? this.form.observacao : '',
            origens: this.origensParaEnvio(),
          });

        if (this.ehTransferencia)
          return conciliacaoProjetoServico.transferirEntreContas(this.idContaCript, {
            idExtrato: this.deteccao.idExtrato,
            idsExtrato: this.idsExtratoEnvio,
            data: this.dataTexto(),
            documento: this.form.documento,
            complemento: this.form.complemento,
            gerarDebitoTransitoria: this.form.gerarDebitoTransitoria,
            origens: this.origensParaEnvio(),
          });

        if (this.ehResgate)
          return conciliacaoProjetoServico.lancarResgate(this.idContaCript, {
            idExtrato: this.deteccao.idExtrato,
            idAplicacao: this.form.idAplicacao,
            data: this.dataTexto(),
            complemento: this.form.complemento,
          });

        return conciliacaoProjetoServico.lancarAplicacao(this.idContaCript, {
          idExtrato: this.deteccao.idExtrato,
          idAplicacao: this.form.idAplicacao,
          data: this.dataTexto(),
          complemento: this.form.complemento,
        });
      },
      erro(campo) { return this.validar ? this.erros[campo] : ''; },
      tituloComErro(indice) {
        if (!this.validar) return false;
        const padrao = new RegExp('^crc' + indice + '[A-Z]');
        return Object.keys(this.erros).some(k => padrao.test(k));
      },
      blocoComErro(indice) {
        if (!this.validar) return false;
        const prefixo = indice === 0 ? 'mov' : 'movx' + indice;
        return Object.keys(this.erros).some(k => k.indexOf(prefixo) === 0 && (indice > 0 || !/^mov(x|Soma)/.test(k)));
      },
      irParaPrimeiroErro() {
        this.$nextTick(() => {
          const alvo = this.$el.querySelector('.rg-invalido, .rt-erro, .og-invalido, .pt-invalido, .rg-tit-erro');
          if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      },
      anexosDosBlocos(blocos) {
        return (blocos || []).reduce((todos, b) => todos.concat(b.anexos || []), []);
      },
      enviosPorBloco(blocos, idsSolicitacao, idsLancamento) {
        const multi = blocos.length > 1;

        return blocos.map((bloco, i) => {
          const sufixo = multi ? ' ' + (i + 1) : '';

          return this.viaSolicitacao
            ? { destino: DESTINO_SOLICITACAO, rotulo: 'solicitação de transferência' + sufixo,
                ids: [idsSolicitacao[i]], arquivos: bloco.anexos || [] }
            : { destino: DESTINO_LANCAMENTO, rotulo: 'transferência' + sufixo,
                ids: [idsLancamento[i * 2], idsLancamento[i * 2 + 1]], arquivos: bloco.anexos || [] };
        });
      },
      listaIds(lista, avulsos) {
        return lista && lista.length ? lista : avulsos;
      },
      enviosAnexos(resultado) {
        const r = resultado || {};

        if (this.ehTransferencia)
          return this.enviosPorBloco(this.form.origens,
            this.listaIds(r.idsSolicitacaoTransferencia, [r.idSolicitacaoTransferencia]),
            this.listaIds(r.idsLancamentoTransferencia, [r.idLancamentoDebito, r.idLancamentoCredito]));

        if (this.ehMovimento) {
          const ids = this.listaIds(r.idsLancamentoConta, [r.idLancamento]);
          const multi = this.lancamentosMov.length > 1;
          return this.lancamentosMov.map((m, i) => ({
            destino: DESTINO_LANCAMENTO, rotulo: 'lançamento' + (multi ? ' ' + (i + 1) : ''),
            ids: [ids[i]], arquivos: m.anexos || [],
          }));
        }

        if (this.ehContaReceberConta) {
          const ids = this.listaIds(r.idsLancamentoConta, [r.idLancamento]);
          const multi = this.crc.titulos.length > 1;
          return this.crc.titulos.map((t, i) => ({
            destino: DESTINO_CONTA_RECEBER, rotulo: 'contas a receber' + (multi ? ' ' + (i + 1) : ''),
            ids: [ids[i]], arquivos: t.anexos || [],
          }));
        }

        if (this.ehCreditoIdentificar) {
          const envios = [];

          if (this.regExigeContaReceber) {
            const ids = this.listaIds(r.idsContaReceber, [r.idContaReceber]);
            this.titulosRegCr.forEach((t, i) => {
              envios.push({ destino: DESTINO_CONTA_RECEBER, rotulo: 'contas a receber' + (this.variosCr ? ' ' + (i + 1) : ''),
                            ids: [ids[i]], arquivos: i === 0 ? this.anexos.creditoContaReceber : (t.anexos || []) });
            });
          }

          if (this.regExigeTransferencia)
            return envios.concat(this.enviosPorBloco(this.reg.destinos,
              this.listaIds(r.idsSolicitacaoTransferencia, [r.idSolicitacaoTransferencia]),
              this.listaIds(r.idsLancamentoTransferencia,
                            [r.idLancamentoDebitoTransferencia, r.idLancamentoCreditoTransferencia])));

          return envios;
        }

        return [];
      },
      confirmar() {
        if (this.gravando) return;

        if (!this.operacao) {
          toastr.warning('Escolha acima ' + (this.creditoNoExtrato ? 'de onde veio este crédito.' : 'para onde foi este débito.'));
          return;
        }

        this.validar = true;

        if (this.ehCreditoIdentificar && !this.configurado) {
          toastr.error('Configure o módulo de créditos a identificar antes de regularizar.');
          return;
        }

        if (Object.keys(this.erros).length > 0) {
          toastr.error(this.erros.crVinculo || this.erros.crSoma || this.erros.crNotaRepetida
            || 'Preencha os campos obrigatórios destacados.');
          this.irParaPrimeiroErro();
          return;
        }

        this.gravando = true;

        this.chamadaConfirmacao()
          .then(resultado => {
            return this.enviarAnexos(this.enviosAnexos(resultado)).then(() => {
              this.gravando = false;
              this.$emit('concluido', resultado);
            });
          })
          .catch(res => {
            this.gravando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível concluir a operação.');
          });
      },
      fechar() { this.$emit('fechar'); },
    },
  }
</script>

<template>
  <div class="ov">
    <div class="ov-modal reg-modal">

      <div class="rg-head">
        <div>
          <h4>{{ titulo }}</h4>
          <div class="rg-sub">
            <span class="mono">{{ deteccao.data }}</span>
            <template v-if="variasLinhas">
              <span class="rg-pt">·</span>
              <span class="rg-qtd-linhas">{{ deteccao.idsExtrato.length }} linhas do extrato</span>
              <template v-if="deteccao.documento">
                <span class="rg-pt">·</span>
                <span class="mono">Doc {{ deteccao.documento }}</span>
              </template>
            </template>
            <template v-else>
              <span v-if="deteccao.historico" class="rg-pt">·</span>
              <span v-if="deteccao.historico" class="mono rg-hist" :title="deteccao.historico">{{ deteccao.historico }}</span>
            </template>
            <span class="rg-pt">·</span>
            <span class="mono">{{ nomeContaExtrato }}</span>
          </div>
        </div>
        <div class="rg-valor">
          <div class="rg-valor-lbl">{{ rotuloValor }}</div>
          <div class="rg-valor-num" :class="ehSaldo || creditoNoExtrato ? 'rg-valor-cre' : 'rg-valor-deb'">R$ {{ formatar(deteccao.valor) }}</div>
        </div>
      </div>

      <div v-if="ehSaldo" class="rg-linhas-ext">
        <div v-for="l in deteccao.lancamentosSaldo" :key="l.idLancamento" class="rg-linha-ext">
          <span class="mono muted">{{ l.data }}</span>
          <span class="rg-linha-ext-hist" :title="l.historico">{{ l.historico }}</span>
          <span v-if="deteccao.boletos" class="mono muted" :title="'Boleto liquidado em ' + l.dataBoleto"><i class="fa fa-check rg-boleto-ok"></i> Nosso nº {{ l.nossoNumero }}</span>
          <span v-else-if="l.documento" class="mono muted">Doc {{ l.documento }}</span>
          <span class="mono rg-linha-ext-valor">R$ {{ formatar(l.valor) }}</span>
        </div>
        <div class="rg-linha-ext rg-linha-ext-soma">
          <span class="mono muted">Soma</span>
          <span class="rg-linha-ext-hist">{{ deteccao.lancamentosSaldo.length }} {{ deteccao.boletos ? 'lançamentos conferidos com o relatório de boletos' : 'lançamentos sem extrato' }}</span>
          <span class="mono rg-linha-ext-valor">R$ {{ formatar(somaSaldoSelecionado) }}</span>
        </div>
      </div>

      <div v-if="ehSaldo && diasSaldoSelecionado > 1" class="rg-aviso-item rg-aviso-dias">
        <i class="fa fa-exclamation-triangle"></i>
        Os lançamentos são de {{ diasSaldoSelecionado }} dias diferentes. O certo é transferir um dia de cada vez, com a data do dia.
      </div>

      <div v-else-if="variasLinhas" class="rg-linhas-ext">
        <div v-for="l in deteccao.linhas" :key="l.idExtrato" class="rg-linha-ext">
          <span class="mono muted">{{ l.idExtrato }}</span>
          <span class="rg-linha-ext-hist" :title="l.historico">{{ l.historico }}</span>
          <span v-if="l.documento" class="mono muted">Doc {{ l.documento }}</span>
          <span class="mono rg-linha-ext-valor">R$ {{ formatar(l.valor) }}</span>
        </div>
      </div>

      <div class="rg-barra">
        <div class="rg-barra-lbl">{{ perguntaOrigem }}</div>
        <div class="rg-abas" role="tablist" :aria-label="perguntaOrigem">
          <button v-for="(op, ix) in operacoesDisponiveis" :key="op.valor" ref="aba" type="button" role="tab"
                  class="rg-aba" :class="{ ativa: operacao === op.valor }"
                  :aria-selected="operacao === op.valor ? 'true' : 'false'"
                  :tabindex="operacao === op.valor || (!operacao && ix === 0) ? 0 : -1"
                  @click="operacao = op.valor"
                  @keydown.left.prevent="moverAba(ix, -1)" @keydown.right.prevent="moverAba(ix, 1)">
            <i class="fa" :class="op.icone"></i>{{ op.curto }}
          </button>
        </div>
        <div v-if="operacaoAtiva" class="rg-barra-aj"><b>{{ operacaoAtiva.titulo }}</b> {{ operacaoAtiva.texto }}</div>
      </div>

      <div class="rg-corpo">

        <div class="rg-passos" role="tabpanel" :aria-label="operacaoAtiva ? operacaoAtiva.titulo : ''">

          <div v-if="!operacao" class="rg-vazio rg-escolha">
            <i class="fa fa-hand-o-up rg-escolha-ic"></i>
            <div>Não deu para saber pelo histórico {{ creditoNoExtrato ? 'de onde veio este crédito' : 'para onde foi este débito' }}.</div>
            <div><b>Escolha o tipo nas abas acima.</b></div>
          </div>

          <div class="rg-passo" v-if="ehTransferencia">
            <bloco-operacao :selo="seloTransferencia" :cor="corTransferencia" :titulo="tituloTransferencia"
                            :subtitulo="subtituloTransferencia">
              <div class="rg-seg-lbl">Efeito</div>
              <div class="rg-seg">
                <button type="button" :class="{ ativo: !viaSolicitacao }" @click="viaSolicitacao = false">Lançar agora</button>
                <button type="button" :class="{ ativo: viaSolicitacao }" @click="viaSolicitacao = true">Pedir liberação</button>
              </div>
              <div class="rg-seg-aj">
                <template v-if="ehSaldo && viaSolicitacao">
                  Cria uma solicitação de transferência por conta, aguardando liberação. <b>Os lançamentos selecionados
                  são conciliados agora</b>; a perna desta conta aparece pendente quando a transferência for executada.
                </template>
                <template v-else-if="ehSaldo">Gera as duas pernas de cada conta agora e concilia tudo junto com os lançamentos selecionados.</template>
                <template v-else-if="viaSolicitacao">
                  Cria uma solicitação de transferência por conta, com o rateio informado, aguardando liberação.
                  <b>Nenhum lançamento é gerado agora</b> e a linha do extrato continua pendente.
                </template>
                <template v-else>Gera as duas pernas de cada conta agora e concilia a linha do extrato.</template>
              </div>

              <origens-transferencia v-model="form.origens" :id-conta-cript="idContaCript"
                                     :id-conta-extrato="deteccao.idConta" :total="deteccao.valor"
                                     :credito-no-extrato="creditoNoExtrato" :nome-conta-extrato="nomeContaExtrato"
                                     :buscar="buscarContas" :validar="validar" :com-observacao="viaSolicitacao"
                                     :com-item="!viaSolicitacao" :consultar-item="true" :anexo="anexoTransferencia"
                                     @valido="v => origensValidas = v"></origens-transferencia>

              <div v-if="viaSolicitacao && algumRateioExigeItem" class="rg-aviso-item">
                As rubricas escolhidas exigem item de controle. A solicitação de transferência não guarda o item —
                ele terá que ser informado na liberação.
              </div>

              <div class="rg-linha">
                <div class="rg-campo rg-campo-sm">
                  <label>Data</label>
                  <date-picker v-model="form.data" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                </div>
                <div class="rg-campo">
                  <label>Documento</label>
                  <complemento-sugerido v-model="form.documento" :digitados="[form.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="50"
                                        placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                </div>
                <div class="rg-campo rg-campo-lg">
                  <label>Complemento <span class="muted">(opcional)</span></label>
                  <complemento-sugerido v-model="form.complemento" :digitados="[form.documento]" titulo-digitados="Do documento" :sugestoes="sugestoesComplemento" :cadastrados="textosComplemento"
                                        placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                </div>
              </div>

              <template v-if="viaSolicitacao">
                <div class="rg-linha">
                  <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('liberador') }">
                    <label>Quem vai liberar <span class="rg-obr">*</span></label>
                    <selecao-busca v-model="form.idUsuarioLiberacao" :texto="form.nomeUsuarioLiberacao" :buscar="buscarUsuarios"
                                   placeholder="Buscar responsável pela liberação..."
                                   @selecionado="o => form.nomeUsuarioLiberacao = o ? o.nome : ''"></selecao-busca>
                    <span v-if="erro('liberador')" class="rg-msg">{{ erro('liberador') }}</span>
                  </div>
                  <div v-if="!observacaoPorConta" class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('observacao') }">
                    <label>Observação <span class="rg-obr">*</span></label>
                    <input type="text" class="form-control" maxlength="300" v-model="form.observacao"
                           placeholder="Motivo da transferência">
                    <span v-if="erro('observacao')" class="rg-msg">{{ erro('observacao') }}</span>
                  </div>
                </div>
              </template>

              <label v-else-if="creditoNoExtrato && !ehSaldo" class="rg-check">
                <input type="checkbox" v-model="form.gerarDebitoTransitoria">
                Gerar também o débito na conta transitória (TRA) para identificação posterior
              </label>

              <div v-if="ehSaldo" class="rg-linha">
                <div class="rg-campo rg-campo-lg">
                  <label>Justificativa <span class="muted">(opcional)</span></label>
                  <textarea class="form-control" rows="2" maxlength="300" v-model="form.justificativa"
                            placeholder="Por que a conta fica sem extrato e como o saldo foi conferido..."></textarea>
                </div>
              </div>
            </bloco-operacao>
          </div>

          <div class="rg-passo" v-if="ehComplemento">
            <bloco-operacao icone="fa-lock" cor="cin"
                            :titulo="deteccao.complemento.lancamentos.length === 1 ? 'Já lançado na conta' : deteccao.complemento.lancamentos.length + ' lançamentos já feitos na conta'"
                            subtitulo="Não serão alterados — entram no mesmo grupo da conciliação">
              <div v-for="l in deteccao.complemento.lancamentos" :key="l.idLancamento" class="rg-tit rg-compl-tit">
                <div class="rg-tit-cab">
                  <span class="rg-compl-cadeado" title="Já lançado — não será alterado"><i class="fa fa-lock"></i></span>
                  <span class="rg-tit-ordem mono">{{ l.idLancamento }}</span>
                  <span class="mono muted">{{ l.data }}</span>
                  <span class="rg-tit-nome" :title="l.historico">{{ l.historico }}</span>
                  <span class="mono rg-compl-valor" :class="l.valorSinal < 0 ? 'rg-valor-deb' : 'rg-valor-cre'">R$ {{ formatar(l.valorSinal) }}</span>
                </div>
                <div v-if="l.documento || l.complemento" class="rg-compl-info">
                  <span v-if="l.documento"><span class="muted">Documento</span> {{ l.documento }}</span>
                  <span v-if="l.complemento"><span class="muted">Complemento</span> {{ l.complemento }}</span>
                </div>
                <table class="rg-compl-rateio">
                  <thead><tr><th>Projeto</th><th>Rubrica</th><th class="num">Valor</th></tr></thead>
                  <tbody>
                    <tr v-for="r in l.rateios" :key="r.idLancRateio">
                      <td>{{ r.projeto }}</td>
                      <td>{{ r.rubrica }}</td>
                      <td class="num mono">R$ {{ formatar(r.valor) }}</td>
                    </tr>
                    <tr v-if="!l.rateios.length"><td colspan="3" class="muted">Sem rateio</td></tr>
                  </tbody>
                </table>
              </div>
              <div class="rg-compl-resumo">
                <span>Extrato <b class="mono">R$ {{ formatar(deteccao.complemento.totalExtrato) }}</b></span>
                <span class="rg-pt">·</span>
                <span>Já lançado <b class="mono">R$ {{ formatar(deteccao.complemento.totalLancado) }}</b></span>
                <span class="rg-pt">·</span>
                <span>Novos <b class="mono">R$ {{ formatar(somaMovimentos) }}</b></span>
                <span class="rg-pt">·</span>
                <span :class="Math.abs(faltaMovimentos) < 0.005 ? 'rg-compl-ok' : 'rg-compl-falta'">
                  {{ Math.abs(faltaMovimentos) < 0.005 ? 'Fecha a diferença' : 'Falta R$ ' + formatar(faltaMovimentos) }}
                </span>
              </div>
            </bloco-operacao>
          </div>

          <div class="rg-passo" v-if="ehMovimento">
            <bloco-operacao :selo="creditoNoExtrato ? 'CRÉD' : 'DÉB'" :cor="creditoNoExtrato ? 'cre' : 'deb'"
                            :titulo="variosMovimentos
                                     ? lancamentosMov.length + (creditoNoExtrato ? ' créditos diretos na conta' : ' débitos diretos na conta')
                                     : (creditoNoExtrato ? 'Crédito direto na conta' : 'Débito direto na conta')"
                            :subtitulo="variosMovimentos
                                        ? 'Cada lançamento com seu rateio — sem contas a receber nem a pagar'
                                        : 'Um lançamento só, rateado no projeto — sem contas a receber nem a pagar'">
              <div :class="{ 'rg-tit rg-tit-primeiro': variosMovimentos, 'rg-tit-erro': variosMovimentos && blocoComErro(0) }">
              <div v-if="variosMovimentos" class="rg-tit-cab">
                <span class="rg-tit-num">1</span>
                <span class="rg-tit-ordem">Lançamento 1 de {{ lancamentosMov.length }}</span>
                <span v-if="blocoComErro(0)" class="rg-tit-pendente"><i class="fa fa-exclamation-circle"></i> Pendente</span>
                <span class="rg-tit-nome">{{ mov.nomeTerceiro || mov.historico || '' }}</span>
                <div class="rg-tit-valor" :class="{ 'rg-invalido': erro('movValor') }">
                  <label>Valor</label>
                  <div class="rg-tit-valor-campo">
                    <input type="text" class="form-control mono" :value="mov.valorTexto" maxlength="20" placeholder="0,00"
                           @input="digitarValorTitulo(mov, $event)" @blur="sairValorMov(mov)">
                    <button v-if="Math.abs(faltaMovimentos) >= 0.005" type="button" class="rg-tit-saldo" @click="usarFalta(mov, faltaMovimentos)"
                            title="Jogar o que falta neste lançamento"><i class="fa fa-level-down"></i></button>
                  </div>
                </div>
              </div>
              <div v-if="creditoNoExtrato && mov.tipoPessoa !== 4 && !mov.notaFiscal" class="rg-nf rg-nf-topo">
                <label>Devolução de solicitação <span class="muted">(opcional)</span></label>
                <devolucao-solicitacao-vinculo :id-conta-cript="idContaCript" :value="mov.devolucao" :total="valorDoMov(mov)" :sugestoes="sugestoesSp"
                                               :invalido="!!erro('movDevolucao')"
                                               @input="d => devolucaoDoMov(mov, d)"></devolucao-solicitacao-vinculo>
                <span v-if="erro('movDevolucao')" class="rg-msg">{{ erro('movDevolucao') }}</span>
              </div>
              <div v-if="creditoNoExtrato && mov.tipoPessoa !== 4 && !mov.devolucao" class="rg-nf rg-nf-topo">
                <label>Nota fiscal <span class="muted">(opcional)</span></label>
                <nota-fiscal-vinculo v-model="mov.notaFiscal" :id-pessoa="mov.idTerceiro || 0" :nome-pessoa="mov.nomeTerceiro" :permitir-outro-cliente="true"
                                     :ids-projeto="idsProjetoDe(mov.rateios)" :total="deteccao.valor" :sugestoes="sugestoesNf" :cria-conta-receber="false"
                                     @cliente="c => clienteDaNotaFiscal(mov, c)"
                                     @rateios="r => rateioDaNotaFiscal(mov, r, true)"></nota-fiscal-vinculo>
              </div>
              <div class="rg-linha">
                <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('movTipoPessoa') || erro('movCliente') || erro('movHistorico') }">
                  <label>{{ creditoNoExtrato ? 'Pagador' : 'Favorecido' }} <span class="rg-obr">*</span></label>
                  <div class="rg-tp">
                    <button type="button" :class="{ ativo: mov.tipoPessoa === 1 }" @click="escolherTipoPessoaBloco(mov, 1)">Pessoa física</button>
                    <button type="button" :class="{ ativo: mov.tipoPessoa === 2 }" @click="escolherTipoPessoaBloco(mov, 2)">Pessoa jurídica</button>
                    <button type="button" :class="{ ativo: mov.tipoPessoa === 4 }" @click="escolherContaCorrente(mov)">Conta corrente</button>
                    <button type="button" :class="{ ativo: mov.tipoPessoa === 3 }" @click="escolherTipoPessoaBloco(mov, 3)">Outros</button>
                  </div>
                  <input v-if="!mov.tipoPessoa" type="text" class="form-control rg-tp-espera" disabled placeholder="Escolha acima: pessoa física, jurídica, conta corrente ou outros">
                  <selecao-busca v-if="mov.tipoPessoa === 4" v-model="mov.idTerceiro" :texto="mov.nomeTerceiro"
                                 :buscar="buscarContasGerais" placeholder="Buscar conta..."
                                 @selecionado="o => contaCorrenteEscolhida(mov, o)"></selecao-busca>
                  <selecao-busca v-if="mov.tipoPessoa === 1 || mov.tipoPessoa === 2" v-model="mov.idTerceiro" :texto="mov.nomeTerceiro"
                                 :buscar="buscarPessoasMov" :placeholder="mov.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                 @selecionado="o => mov.nomeTerceiro = o ? o.nome : ''"></selecao-busca>
                  <complemento-sugerido v-if="semClienteMov" v-model="mov.historico" :sugestoes="sugestoesHistorico" :cadastrados="textosHistorico" :maxlength="110"
                                        placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                  <span v-if="erro('movTipoPessoa')" class="rg-msg">{{ erro('movTipoPessoa') }}</span>
                  <span v-else-if="erro('movCliente')" class="rg-msg">{{ erro('movCliente') }}</span>
                  <span v-else-if="erro('movHistorico')" class="rg-msg">{{ erro('movHistorico') }}</span>
                  <small v-else-if="semClienteMov" class="rg-dica">O lançamento nasce sem pessoa, com este histórico.</small>
                </div>
              </div>

              <div class="rg-linha">
                <div v-if="usaCategoria" class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('movCategoria') }">
                  <label>Categoria financeira <span v-if="categoriaObrigatoria" class="rg-obr">*</span></label>
                  <selecao-busca v-model="mov.idCategoriaFinanceira" :texto="mov.nomeCategoriaFinanceira"
                                 :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                 @selecionado="o => mov.nomeCategoriaFinanceira = o ? o.nome : ''"></selecao-busca>
                  <span v-if="erro('movCategoria')" class="rg-msg">{{ erro('movCategoria') }}</span>
                </div>
                <div class="rg-campo rg-campo-sm">
                  <label>Forma de pagamento</label>
                  <select class="form-control" v-model.number="mov.formaPagamento">
                    <option :value="-1"></option>
                    <option v-for="(nome, indice) in formasPagamento" :key="indice" :value="indice">{{ nome }}</option>
                  </select>
                </div>
                <div class="rg-campo rg-campo-sm">
                  <label>Data</label>
                  <date-picker v-model="form.data" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                </div>
              </div>

              <rateio-projetos v-if="!mov.devolucao" v-model="mov.rateios" :id-conta-cript="idContaCript" :total="valorDoMov(mov)" :acompanhar-total="true"
                               :natureza="creditoNoExtrato ? 'C' : 'D'" :validar="validar"
                               :com-item="true" :com-quantidade="true"
                               @sem-projetos="v => semRateioConta = v"></rateio-projetos>

              <label v-if="creditoNoExtrato && taxaMov.mostrar" class="rg-check">
                <input type="checkbox" v-model="taxaMov.marcado">
                <span>Taxa <small class="muted">— marcado quando o projeto tem taxa cadastrada</small></span>
              </label>

              <div class="rg-linha">
                <div class="rg-campo">
                  <label>Documento</label>
                  <complemento-sugerido v-model="mov.documento" :digitados="[mov.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="50"
                                        :sugestoes="textosDevolucao(mov, false)" titulo-sugestoes="Devolução da solicitação" :sugestoes-primeiro="!!mov.devolucao"
                                        placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                </div>
                <div class="rg-campo rg-campo-lg">
                  <label>Complemento <span class="muted">(opcional)</span></label>
                  <complemento-sugerido v-model="mov.complemento" :digitados="[mov.documento]" titulo-digitados="Do documento"
                                        :sugestoes="mov.devolucao ? textosDevolucao(mov, true).concat(sugestoesComplemento) : sugestoesComplemento"
                                        :titulo-sugestoes="mov.devolucao ? 'Devolução da solicitação e extrato' : 'Sugestões do extrato'" :sugestoes-primeiro="!!mov.devolucao"
                                        :cadastrados="textosComplemento"
                                        placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                </div>
              </div>

              <div class="rg-anexo" v-if="podeAnexarLancamento">
                <anexos-operacao v-model="mov.anexos" :limite="limiteAnexo" :origens="origensLinha"
                                 :titulo="variosMovimentos ? 'Arquivos · lançamento 1' : 'Arquivos do lançamento'"
                                 dica="Os arquivos vão para a pasta de lançamentos, no lançamento criado."></anexos-operacao>
              </div>
              </div>

              <div v-for="(m, i) in movExtras" :key="m.chave" class="rg-tit" :class="{ 'rg-tit-erro': blocoComErro(i + 1) }">
                <div class="rg-tit-cab">
                  <span class="rg-tit-num">{{ i + 2 }}</span>
                  <span class="rg-tit-ordem">Lançamento {{ i + 2 }} de {{ lancamentosMov.length }}</span>
                  <span v-if="blocoComErro(i + 1)" class="rg-tit-pendente"><i class="fa fa-exclamation-circle"></i> Pendente</span>
                  <span class="rg-tit-nome">{{ m.nomeTerceiro || m.historico || '' }}</span>
                  <div class="rg-tit-valor" :class="{ 'rg-invalido': erro('movx' + (i + 1) + 'Valor') }">
                    <label>Valor</label>
                    <div class="rg-tit-valor-campo">
                      <input type="text" class="form-control mono" :value="m.valorTexto" maxlength="20" placeholder="0,00"
                             @input="digitarValorTitulo(m, $event)" @blur="sairValorMov(m)">
                      <button v-if="Math.abs(faltaMovimentos) >= 0.005" type="button" class="rg-tit-saldo" @click="usarFalta(m, faltaMovimentos)"
                              title="Jogar o que falta neste lançamento"><i class="fa fa-level-down"></i></button>
                    </div>
                  </div>
                  <button type="button" class="rg-tit-remover" title="Remover este lançamento" @click="removerMovimento(i)"><i class="fa fa-trash-o"></i></button>
                </div>

                <div v-if="creditoNoExtrato && m.tipoPessoa !== 4 && !m.devolucao" class="rg-nf rg-nf-topo">
                  <label>Nota fiscal <span class="muted">(opcional)</span></label>
                  <nota-fiscal-vinculo v-model="m.notaFiscal" :id-pessoa="m.idTerceiro || 0" :nome-pessoa="m.nomeTerceiro" :permitir-outro-cliente="true"
                                       :ids-projeto="idsProjetoDe(m.rateios)" :total="valorDoMov(m)" :sugestoes="sugestoesNf" :cria-conta-receber="false"
                                       @cliente="c => clienteDaNotaFiscal(m, c)"
                                       @rateios="r => rateioDaNotaFiscal(m, r, true)"></nota-fiscal-vinculo>
                </div>

                <div v-if="creditoNoExtrato && m.tipoPessoa !== 4" class="rg-nf rg-nf-topo">
                  <label>Devolução de solicitação <span class="muted">(opcional)</span></label>
                  <devolucao-solicitacao-vinculo :id-conta-cript="idContaCript" :value="m.devolucao" :total="valorDoMov(m)" :sugestoes="sugestoesSp"
                                                 :invalido="!!erro('movx' + (i + 1) + 'Devolucao')"
                                                 @input="d => devolucaoDoMov(m, d)"></devolucao-solicitacao-vinculo>
                  <span v-if="erro('movx' + (i + 1) + 'Devolucao')" class="rg-msg">{{ erro('movx' + (i + 1) + 'Devolucao') }}</span>
                </div>

                <div class="rg-linha">
                  <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('movx' + (i + 1) + 'TipoPessoa') || erro('movx' + (i + 1) + 'Cliente') || erro('movx' + (i + 1) + 'Historico') }">
                    <label>{{ creditoNoExtrato ? 'Pagador' : 'Favorecido' }} <span class="rg-obr">*</span></label>
                    <div class="rg-tp">
                      <button type="button" :class="{ ativo: m.tipoPessoa === 1 }" @click="escolherTipoPessoaBloco(m, 1)">Pessoa física</button>
                      <button type="button" :class="{ ativo: m.tipoPessoa === 2 }" @click="escolherTipoPessoaBloco(m, 2)">Pessoa jurídica</button>
                      <button type="button" :class="{ ativo: m.tipoPessoa === 4 }" @click="escolherContaCorrente(m)">Conta corrente</button>
                      <button type="button" :class="{ ativo: m.tipoPessoa === 3 }" @click="escolherTipoPessoaBloco(m, 3)">Outros</button>
                    </div>
                    <input v-if="!m.tipoPessoa" type="text" class="form-control rg-tp-espera" disabled placeholder="Escolha acima: pessoa física, jurídica, conta corrente ou outros">
                    <selecao-busca v-if="m.tipoPessoa === 4" v-model="m.idTerceiro" :texto="m.nomeTerceiro"
                                   :buscar="buscarContasGerais" placeholder="Buscar conta..."
                                   @selecionado="o => contaCorrenteEscolhida(m, o)"></selecao-busca>
                    <selecao-busca v-if="m.tipoPessoa === 1 || m.tipoPessoa === 2" v-model="m.idTerceiro" :texto="m.nomeTerceiro"
                                   :buscar="buscarPessoasTitulo(m)" :placeholder="m.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                   @selecionado="o => m.nomeTerceiro = o ? o.nome : ''"></selecao-busca>
                    <complemento-sugerido v-if="m.tipoPessoa === 3" v-model="m.historico" :sugestoes="sugestoesHistorico" :cadastrados="textosHistorico" :maxlength="110"
                                          placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                    <span v-if="erro('movx' + (i + 1) + 'TipoPessoa')" class="rg-msg">{{ erro('movx' + (i + 1) + 'TipoPessoa') }}</span>
                    <span v-else-if="erro('movx' + (i + 1) + 'Cliente')" class="rg-msg">{{ erro('movx' + (i + 1) + 'Cliente') }}</span>
                    <span v-else-if="erro('movx' + (i + 1) + 'Historico')" class="rg-msg">{{ erro('movx' + (i + 1) + 'Historico') }}</span>
                  </div>
                  <div v-if="usaCategoria" class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('movx' + (i + 1) + 'Categoria') }">
                    <label>Categoria financeira <span v-if="categoriaObrigatoria" class="rg-obr">*</span></label>
                    <selecao-busca v-model="m.idCategoriaFinanceira" :texto="m.nomeCategoriaFinanceira"
                                   :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                   @selecionado="o => m.nomeCategoriaFinanceira = o ? o.nome : ''"></selecao-busca>
                    <span v-if="erro('movx' + (i + 1) + 'Categoria')" class="rg-msg">{{ erro('movx' + (i + 1) + 'Categoria') }}</span>
                  </div>
                </div>

                <rateio-projetos v-if="!m.devolucao" v-model="m.rateios" :id-conta-cript="idContaCript" :total="valorDoMov(m)" :acompanhar-total="true"
                                 :natureza="creditoNoExtrato ? 'C' : 'D'" :validar="validar"
                                 :com-item="true" :com-quantidade="true"
                                 @sem-projetos="v => semRateioConta = v"></rateio-projetos>

                <div class="rg-linha">
                  <div class="rg-campo">
                    <label>Documento</label>
                    <complemento-sugerido v-model="m.documento" :digitados="[m.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="50"
                                          :sugestoes="textosDevolucao(m, false)" titulo-sugestoes="Devolução da solicitação" :sugestoes-primeiro="!!m.devolucao"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                  <div class="rg-campo rg-campo-lg">
                    <label>Complemento <span class="muted">(opcional)</span></label>
                    <complemento-sugerido v-model="m.complemento" :digitados="[m.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento"
                                          :sugestoes="m.devolucao ? textosDevolucao(m, true).concat(sugestoesComplemento) : sugestoesComplemento"
                                          :titulo-sugestoes="m.devolucao ? 'Devolução da solicitação e extrato' : 'Sugestões do extrato'" :sugestoes-primeiro="!!m.devolucao"
                                          placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                  </div>
                </div>

                <div class="rg-anexo" v-if="podeAnexarLancamento">
                  <anexos-operacao v-model="m.anexos" :limite="limiteAnexo" :origens="origensLinha"
                                   :titulo="'Arquivos · lançamento ' + (i + 2)"
                                   dica="Os arquivos vão para a pasta de lançamentos, no lançamento criado."></anexos-operacao>
                </div>
              </div>

              <div class="rg-tit-rodape">
                <button type="button" class="rg-tit-add" @click="adicionarMovimento"><i class="fa fa-plus"></i> Adicionar lançamento</button>
                <span v-if="variosMovimentos" class="rg-tit-soma" :class="Math.abs(faltaMovimentos) < 0.005 ? 'ok' : 'falta'">
                  {{ lancamentosMov.length }} lançamentos · R$ {{ formatar(somaMovimentos) }}
                  <template v-if="Math.abs(faltaMovimentos) < 0.005"> · {{ ehComplemento ? 'fecha a diferença' : 'bate com o extrato' }}</template>
                  <template v-else-if="faltaMovimentos > 0"> · faltam R$ {{ formatar(faltaMovimentos) }}</template>
                  <template v-else> · passou R$ {{ formatar(-faltaMovimentos) }}</template>
                </span>
              </div>

            </bloco-operacao>
          </div>

          <div class="rg-passo" v-if="ehContaReceberConta">
            <bloco-operacao selo="CR" cor="cre" :titulo="variosTitulos ? crc.titulos.length + ' contas a receber' : 'Contas a receber'"
                            :subtitulo="'Título criado na ' + nomeContaExtrato"
                            :nota="crc.baixarAgora
                                   ? (variosTitulos ? 'Nascem baixados e conciliados com este crédito.' : 'Nasce baixado e conciliado com este crédito.')
                                   : 'Nasce em aberto — a linha do extrato continua pendente.'">
              <div class="rg-nf rg-nf-topo">
                <label>Notas fiscais <span class="muted">(opcional)</span></label>
                <nota-fiscal-vinculo :multipla="true" :notas-marcadas="notasDosTitulos" :total="deteccao.valor" :sugestoes="sugestoesNf"
                                     @escolhidas="notasEscolhidas"></nota-fiscal-vinculo>
              </div>

              <div class="rg-opcoes">
                <label class="rg-radio" :class="{ 'rg-radio-on': crc.baixarAgora === true }">
                  <input type="radio" :value="true" v-model="crc.baixarAgora">
                  <span><b>Baixar agora</b><small>{{ variosTitulos ? 'os títulos nascem conciliados' : 'o título nasce conciliado' }} com este crédito</small></span>
                </label>
                <label class="rg-radio" :class="{ 'rg-radio-on': crc.baixarAgora === false }">
                  <input type="radio" :value="false" v-model="crc.baixarAgora">
                  <span><b>Deixar em aberto</b><small>a linha do extrato continua pendente</small></span>
                </label>
              </div>

              <div v-if="variosTitulos" class="rg-linha">
                <div class="rg-campo rg-campo-sm">
                  <label>Emissão</label>
                  <date-picker v-model="crc.dataEmissao" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                </div>
                <div class="rg-campo rg-campo-sm" :class="{ 'rg-invalido': erro('crcVencimento') }">
                  <label>Vencimento <span class="rg-obr">*</span></label>
                  <date-picker v-model="crc.dataVencimento" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                  <span v-if="erro('crcVencimento')" class="rg-msg">{{ erro('crcVencimento') }}</span>
                </div>
              </div>

              <div v-for="(t, i) in crc.titulos" :key="t.chave" :class="{ 'rg-tit': variosTitulos, 'rg-tit-erro': variosTitulos && tituloComErro(i) }">
                <div v-if="variosTitulos" class="rg-tit-cab">
                  <span class="rg-tit-num">{{ i + 1 }}</span>
                  <span class="rg-tit-ordem">Título {{ i + 1 }} de {{ crc.titulos.length }}</span>
                  <span v-if="tituloComErro(i)" class="rg-tit-pendente"><i class="fa fa-exclamation-circle"></i> Pendente</span>
                  <b>{{ t.notaFiscal ? 'NF ' + t.notaFiscal.numero : 'Sem NF' }}</b>
                  <span class="rg-tit-nome">{{ t.nomeTerceiro || (t.notaFiscal && t.notaFiscal.nomePessoa) || '' }}</span>
                  <div class="rg-tit-valor" :class="{ 'rg-invalido': erro('crc' + i + 'Valor') }">
                    <label>Valor</label>
                    <div class="rg-tit-valor-campo">
                      <input type="text" class="form-control mono" :value="t.valorTexto" maxlength="20" placeholder="0,00"
                             @input="digitarValorTitulo(t, $event)" @blur="sairValorTitulo(t)">
                      <button v-if="Math.abs(faltaTitulos) >= 0.005" type="button" class="rg-tit-saldo" @click="usarFalta(t, faltaTitulos)"
                              title="Jogar o que falta neste título"><i class="fa fa-level-down"></i></button>
                    </div>
                  </div>
                  <button type="button" class="rg-tit-remover" title="Remover este título" @click="removerTitulo(i)"><i class="fa fa-trash-o"></i></button>
                </div>

                <div v-if="t.notaFiscal" class="rg-nf rg-nf-titulo">
                  <label>Nota fiscal <span class="muted">(opcional)</span></label>
                  <nota-fiscal-vinculo :value="t.notaFiscal" @input="nf => notaFiscalDoTitulo(t, nf)"
                                       :id-pessoa="t.idTerceiro || 0" :nome-pessoa="t.nomeTerceiro" :permitir-outro-cliente="true"
                                       :ids-projeto="idsProjetoDe(t.rateios)" :total="valorDoTitulo(t)" :sugestoes="sugestoesNf"
                                       @cliente="c => clienteDaNotaFiscal(t, c)"
                                       @rateios="r => rateioDaNotaFiscal(t, r)"></nota-fiscal-vinculo>
                  <div v-if="avisoPagador(t)" class="rg-aviso-pagador"><i class="fa fa-exclamation-triangle"></i> {{ avisoPagador(t) }}</div>
                </div>

                <div class="rg-linha">
                  <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('crc' + i + 'TipoPessoa') || erro('crc' + i + 'Cliente') || erro('crc' + i + 'Historico') }">
                    <label>Cliente <span class="rg-obr">*</span></label>
                    <div class="rg-tp">
                      <button type="button" :class="{ ativo: t.tipoPessoa === 1 }" @click="escolherTipoPessoaBloco(t, 1)">Pessoa física</button>
                      <button type="button" :class="{ ativo: t.tipoPessoa === 2 }" @click="escolherTipoPessoaBloco(t, 2)">Pessoa jurídica</button>
                      <button type="button" :class="{ ativo: t.tipoPessoa === 3 }" @click="escolherTipoPessoaBloco(t, 3)">Outros</button>
                    </div>
                    <input v-if="!(t.tipoPessoa > 0)" type="text" class="form-control rg-tp-espera" disabled placeholder="Escolha acima: pessoa física, jurídica ou outros">
                    <selecao-busca v-if="t.tipoPessoa > 0 && t.tipoPessoa !== 3" v-model="t.idTerceiro" :texto="t.nomeTerceiro"
                                   :buscar="buscarPessoasTitulo(t)" :placeholder="t.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                   @selecionado="o => t.nomeTerceiro = o ? o.nome : ''"></selecao-busca>
                    <complemento-sugerido v-if="t.tipoPessoa === 3" v-model="t.historico" :sugestoes="sugestoesHistorico" :cadastrados="textosHistorico" :maxlength="110"
                                          placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                    <span v-if="erro('crc' + i + 'TipoPessoa')" class="rg-msg">{{ erro('crc' + i + 'TipoPessoa') }}</span>
                    <span v-else-if="erro('crc' + i + 'Cliente')" class="rg-msg">{{ erro('crc' + i + 'Cliente') }}</span>
                    <span v-else-if="erro('crc' + i + 'Historico')" class="rg-msg">{{ erro('crc' + i + 'Historico') }}</span>
                    <small v-else-if="t.tipoPessoa === 3" class="rg-dica">O título nasce sem cliente, com este histórico.</small>
                  </div>
                </div>

                <div v-if="usaCategoria || !variosTitulos" class="rg-linha">
                  <div v-if="usaCategoria" class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('crc' + i + 'Categoria') }">
                    <label>Categoria financeira <span v-if="categoriaObrigatoria" class="rg-obr">*</span></label>
                    <selecao-busca v-model="t.idCategoriaFinanceira" :texto="t.nomeCategoriaFinanceira"
                                   :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                   @selecionado="o => escolherCategoriaTitulo(t, o)"></selecao-busca>
                    <span v-if="erro('crc' + i + 'Categoria')" class="rg-msg">{{ erro('crc' + i + 'Categoria') }}</span>
                  </div>
                  <div v-if="!variosTitulos" class="rg-campo rg-campo-sm">
                    <label>Emissão</label>
                    <date-picker v-model="crc.dataEmissao" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                  </div>
                  <div v-if="!variosTitulos" class="rg-campo rg-campo-sm" :class="{ 'rg-invalido': erro('crcVencimento') }">
                    <label>Vencimento <span class="rg-obr">*</span></label>
                    <date-picker v-model="crc.dataVencimento" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                    <span v-if="erro('crcVencimento')" class="rg-msg">{{ erro('crcVencimento') }}</span>
                  </div>
                </div>

                <rateio-projetos v-model="t.rateios" :id-conta-cript="idContaCript" :total="valorDoTitulo(t)"
                                 natureza="C" :validar="validar"
                                 @sem-projetos="v => semRateioConta = v"></rateio-projetos>

                <label v-if="crc.baixarAgora && t.taxa.mostrar" class="rg-check">
                  <input type="checkbox" v-model="t.taxa.marcado">
                  <span>Taxa <small class="muted">— marcado quando o projeto tem taxa cadastrada</small></span>
                </label>

                <div class="rg-linha">
                  <div class="rg-campo">
                    <label>Documento</label>
                    <complemento-sugerido v-model="t.documento" :digitados="[t.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                  <div class="rg-campo rg-campo-lg">
                    <label>Complemento <span class="muted">(opcional)</span></label>
                    <complemento-sugerido v-model="t.complemento" :digitados="[t.documento]" titulo-digitados="Do documento" :sugestoes="sugestoesComplemento" :cadastrados="textosComplemento"
                                          placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                  </div>
                </div>

                <div class="rg-anexo" v-if="podeAnexarContaReceber">
                  <anexos-operacao v-model="t.anexos" :limite="limiteAnexo" :origens="origensLinha"
                                   :titulo="variosTitulos ? 'Arquivos · título ' + (i + 1) : 'Arquivos do contas a receber'"
                                   dica="Os arquivos vão para a pasta do contas a receber assim que o título for criado."></anexos-operacao>
                </div>
              </div>

              <div class="rg-tit-rodape">
                <button type="button" class="rg-tit-add" @click="adicionarTitulo"><i class="fa fa-plus"></i> Adicionar título</button>
                <span v-if="variosTitulos" class="rg-tit-soma" :class="Math.abs(faltaTitulos) < 0.005 ? 'ok' : 'falta'">
                  {{ crc.titulos.length }} títulos · R$ {{ formatar(somaTitulos) }}
                  <template v-if="Math.abs(faltaTitulos) < 0.005"> · bate com o crédito</template>
                  <template v-else-if="faltaTitulos > 0"> · faltam R$ {{ formatar(faltaTitulos) }}</template>
                  <template v-else> · passou R$ {{ formatar(-faltaTitulos) }}</template>
                </span>
              </div>

            </bloco-operacao>
          </div>

          <div class="rg-passo" v-if="ehResgate">
            <div class="rg-passo-tit rg-passo-tit-acao"><span>Aplicação de origem</span><button type="button" class="rg-recarregar" :disabled="carregandoAplicacoes" @click="carregarAplicacoes" title="Buscar de novo as aplicações da conta"><i class="fa fa-refresh" :class="{ 'fa-spin': carregandoAplicacoes }"></i> Atualizar</button></div>
            <div class="rg-caixa">
              <div v-if="carregandoAplicacoes" class="rg-vazio"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

              <template v-else>
                <div v-if="aplicacoes.length === 0" class="rg-alerta">
                  Esta conta não tem aplicação ativa. Cadastre a aplicação antes de lançar o resgate.
                </div>

                <div v-else class="apl-lista">
                  <div class="apl-head">
                    <span class="apl-tipo">Aplicação</span>
                    <span class="apl-proj">Projeto</span>
                    <span class="apl-data">Aplicada em</span>
                    <span class="apl-valor">Valor</span>
                    <span class="apl-data">Resgate</span>
                    <span class="apl-saldo">Saldo atual</span>
                  </div>
                  <div v-if="erro('aplicacao')" class="rg-msg rg-msg-bloco">{{ erro('aplicacao') }}</div>
                  <label v-for="a in aplicacoes" :key="a.idAplicacao" class="apl-item"
                         :class="{ sel: form.idAplicacao === a.idAplicacao }">
                    <input type="radio" :value="a.idAplicacao" :checked="form.idAplicacao === a.idAplicacao"
                           @change="escolherAplicacao(a)">
                    <span class="apl-tipo">{{ a.nomeTipoAplicacao || 'Aplicação' }}</span>
                    <span class="apl-proj">{{ a.nomeProjeto }}</span>
                    <span class="apl-data mono">{{ a.dataAplicacao }}</span>
                    <span class="apl-valor mono">{{ formatar(a.valorInicial) }}</span>
                    <span class="apl-data mono">{{ a.dataResgate }}</span>
                    <span class="apl-saldo mono">{{ formatar(a.saldo) }}</span>
                  </label>
                </div>

                <div class="rg-linha">
                  <div class="rg-campo rg-campo-lg">
                    <label>Complemento <span class="muted">(opcional)</span></label>
                    <complemento-sugerido v-model="form.complemento" :digitados="[form.documento]" titulo-digitados="Do documento" :sugestoes="sugestoesComplemento" :cadastrados="textosComplemento"
                                          placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="rg-passo" v-if="ehAplicacao">
            <div class="rg-passo-tit rg-passo-tit-acao"><span>Em qual aplicação?</span><button type="button" class="rg-recarregar" :disabled="carregandoAplicacoes" @click="carregarAplicacoes" title="Buscar de novo as aplicações da conta"><i class="fa fa-refresh" :class="{ 'fa-spin': carregandoAplicacoes }"></i> Atualizar</button></div>
            <div class="rg-caixa">
              <div v-if="carregandoAplicacoes" class="rg-vazio"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

              <template v-else>
                <div v-if="aplicacoesAporte.length === 0" class="rg-alerta">
                  Esta conta não tem aplicação ativa. Cadastre a aplicação no Desktop antes de lançar o aporte.
                </div>

                <div v-else class="apl-lista">
                  <div class="apl-head">
                    <span class="apl-tipo">Aplicação</span>
                    <span class="apl-proj">Projeto</span>
                    <span class="apl-data">Aplicada em</span>
                    <span class="apl-valor">Valor</span>
                    <span class="apl-data">Resgate</span>
                    <span class="apl-saldo">Saldo atual</span>
                  </div>
                  <label v-for="a in aplicacoesAporte" :key="a.idAplicacao" class="apl-item"
                         :class="{ sel: form.idAplicacao === a.idAplicacao }">
                    <input type="radio" :value="a.idAplicacao" :checked="form.idAplicacao === a.idAplicacao"
                           @change="escolherAplicacao(a)">
                    <span class="apl-tipo">{{ a.nomeTipoAplicacao || 'Aplicação' }}</span>
                    <span class="apl-proj">{{ a.nomeProjeto }}</span>
                    <span class="apl-data mono">{{ a.dataAplicacao }}</span>
                    <span class="apl-valor mono">{{ formatar(a.valorInicial) }}</span>
                    <span class="apl-data mono">{{ a.dataResgate }}</span>
                    <span class="apl-saldo mono">{{ formatar(a.saldo) }}</span>
                  </label>
                </div>

                <div class="rg-linha">
                  <div class="rg-campo rg-campo-lg">
                    <label>Complemento <span class="muted">(opcional)</span></label>
                    <complemento-sugerido v-model="form.complemento" :digitados="[form.documento]" titulo-digitados="Do documento" :sugestoes="sugestoesComplemento" :cadastrados="textosComplemento"
                                          placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <template v-if="ehCreditoIdentificar">
            <div class="rg-passo">
              <div class="rg-passo-tit">O que já se sabe sobre o crédito?</div>

              <div v-if="!carregandoConfig && !configurado" class="rg-alerta">
                Configure o projeto, a conta transitória, a rubrica e a subrubrica de créditos a identificar em
                <b>Conciliação de Banco &rarr; Configurações</b> antes de usar esta opção.
              </div>

              <div class="rg-chips">
                <button v-for="s in subcasosCredito" :key="s.valor" type="button"
                        class="rg-chip" :class="{ ativo: reg.tipo === s.valor }" @click="reg.tipo = s.valor">
                  {{ s.curto }}
                </button>
              </div>
              <div v-if="subcasoAtivo" class="rg-chips-aj"><b>{{ subcasoAtivo.titulo }}</b> {{ subcasoAtivo.texto }}</div>
            </div>

            <div class="rg-passo">
              <bloco-operacao selo="TRA" cor="deb" titulo="Crédito na conta e débito na transitória"
                              :subtitulo="'Par que sempre nasce nesta operação: crédito na ' + nomeContaExtrato + ' e débito na ' + contaTransitoria"
                              nota="Este par não recebe arquivos — anexe no contas a receber ou na transferência.">
                <div class="rg-linha">
                  <div class="rg-campo">
                    <label>Documento</label>
                    <complemento-sugerido v-model="reg.documento" :digitados="[reg.complemento]" titulo-digitados="Do complemento" :sugestoes="sugestoesTraDocumento" :cadastrados="textosDocumento" :maxlength="50"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                  <div class="rg-campo rg-campo-lg">
                    <label>Complemento <span class="muted">(opcional)</span></label>
                    <complemento-sugerido v-model="reg.complemento" :digitados="[reg.documento]" titulo-digitados="Do documento" :sugestoes="sugestoesTraComplemento" :cadastrados="textosComplemento"
                                          placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                  </div>
                </div>
              </bloco-operacao>

              <template v-if="regExigeContaReceber">
                <bloco-operacao selo="CR" cor="cre" :titulo="variosCr ? titulosRegCr.length + ' contas a receber a criar' : 'Contas a receber a criar'"
                                :subtitulo="variosCr ? 'Títulos do cliente identificado, para a transferência baixar depois' : 'Título do cliente identificado, para a transferência baixar depois'">
                  <div :class="{ 'rg-tit rg-tit-primeiro': variosCr, 'rg-tit-erro': variosCr && crComErro(0) }">
                  <div v-if="variosCr" class="rg-tit-cab">
                    <span class="rg-tit-num">1</span>
                    <span class="rg-tit-ordem">Título 1 de {{ titulosRegCr.length }}</span>
                    <span v-if="crComErro(0)" class="rg-tit-pendente"><i class="fa fa-exclamation-circle"></i> Pendente</span>
                    <b>{{ reg.cr.notaFiscal ? 'NF ' + reg.cr.notaFiscal.numero : 'Sem NF' }}</b>
                    <span class="rg-tit-nome">{{ reg.cr.nomeTerceiro || reg.cr.historico || '' }}</span>
                    <div class="rg-tit-valor" :class="{ 'rg-invalido': erro('crValor') }">
                      <label>Valor</label>
                      <div class="rg-tit-valor-campo">
                        <input type="text" class="form-control mono" :value="reg.cr.valorTexto" maxlength="20" placeholder="0,00"
                               @input="digitarValorTitulo(reg.cr, $event)" @blur="sairValorTitulo(reg.cr)">
                        <button v-if="Math.abs(faltaRegCr) >= 0.005" type="button" class="rg-tit-saldo" @click="usarFalta(reg.cr, faltaRegCr)"
                                title="Jogar o que falta neste título"><i class="fa fa-level-down"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="rg-nf rg-nf-topo">
                    <label>Nota fiscal <span class="muted">(opcional)</span></label>
                    <nota-fiscal-vinculo v-model="reg.cr.notaFiscal" :id-pessoa="reg.cr.idTerceiro || 0" :nome-pessoa="reg.cr.nomeTerceiro" :permitir-outro-cliente="true"
                                         :ids-projeto="idsProjetoDe(reg.cr.rateios)" :total="valorRegCr(reg.cr)" :sugestoes="sugestoesNf"
                                         @cliente="c => clienteDaNotaFiscal(reg.cr, c)"
                                         @rateios="r => rateioDaNotaFiscal(reg.cr, r)"></nota-fiscal-vinculo>
                  </div>
                  <div class="rg-linha">
                    <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('crTipoPessoa') || erro('crCliente') || erro('crHistorico') }">
                      <label>Cliente <span class="rg-obr">*</span></label>
                      <div class="rg-tp">
                        <button type="button" :class="{ ativo: reg.cr.tipoPessoa === 1 }" @click="escolherTipoPessoaBloco(reg.cr, 1)">Pessoa física</button>
                        <button type="button" :class="{ ativo: reg.cr.tipoPessoa === 2 }" @click="escolherTipoPessoaBloco(reg.cr, 2)">Pessoa jurídica</button>
                        <button type="button" :class="{ ativo: reg.cr.tipoPessoa === 3 }" @click="escolherTipoPessoaBloco(reg.cr, 3)">Outros</button>
                      </div>
                      <input v-if="!(reg.cr.tipoPessoa > 0)" type="text" class="form-control rg-tp-espera" disabled placeholder="Escolha acima: pessoa física, jurídica ou outros">
                      <selecao-busca v-if="reg.cr.tipoPessoa > 0 && !semClienteRegCr" v-model="reg.cr.idTerceiro" :texto="reg.cr.nomeTerceiro"
                                     :buscar="buscarPessoasRegCr" :placeholder="reg.cr.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                     @selecionado="o => reg.cr.nomeTerceiro = o ? o.nome : ''"></selecao-busca>
                      <complemento-sugerido v-if="semClienteRegCr" v-model="reg.cr.historico" :sugestoes="sugestoesHistorico" :cadastrados="textosHistorico" :maxlength="110"
                                            placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                      <span v-if="erro('crTipoPessoa')" class="rg-msg">{{ erro('crTipoPessoa') }}</span>
                      <span v-else-if="erro('crCliente')" class="rg-msg">{{ erro('crCliente') }}</span>
                      <span v-else-if="erro('crHistorico')" class="rg-msg">{{ erro('crHistorico') }}</span>
                      <small v-else-if="semClienteRegCr" class="rg-dica">O título nasce sem pessoa, com este histórico.</small>
                    </div>
                    <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('crConta') }">
                      <label>Conta do título <span class="rg-obr">*</span></label>
                      <selecao-busca ref="crConta" v-model="reg.cr.idConta" :texto="reg.cr.nomeConta"
                                     :buscar="buscarContasGerais" placeholder="Conta onde o título nasce..."
                                     @selecionado="o => reg.cr.nomeConta = o ? o.nome : ''"></selecao-busca>
                      <span v-if="erro('crConta')" class="rg-msg">{{ erro('crConta') }}</span>
                      <small v-else-if="crNaTransitoria" class="rg-dica">A conta transitória. Troque se o título deve nascer em outra conta.</small>
                      <small v-else-if="!reg.cr.idConta && contaDoTituloCr > 0" class="rg-dica">
                        Sem escolher, o título nasce na primeira conta de destino da transferência.
                      </small>
                    </div>
                  </div>

                  <div class="rg-linha" v-if="usaCategoria">
                    <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('crCategoria') }">
                      <label>Categoria financeira <span v-if="categoriaObrigatoria" class="rg-obr">*</span></label>
                      <selecao-busca v-model="reg.cr.idCategoriaFinanceira" :texto="reg.cr.nomeCategoriaFinanceira"
                                     :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                     @selecionado="o => reg.cr.nomeCategoriaFinanceira = o ? o.nome : ''"></selecao-busca>
                      <span v-if="erro('crCategoria')" class="rg-msg">{{ erro('crCategoria') }}</span>
                    </div>
                  </div>

                  <rateio-projetos v-model="reg.cr.rateios" :id-conta-cript="idContaCript" :total="valorRegCr(reg.cr)"
                                   :id-conta-alvo="contaDoTituloCr" natureza="C" :validar="validar" :projetos-livres="crNaTransitoria"
                                   :desabilitado="!(contaDoTituloCr > 0)"
                                   aviso="Escolha a conta do título para informar o rateio."
                                   @sem-projetos="v => semRateioCr = v"></rateio-projetos>

                  <label v-if="taxaRegCr.mostrar" class="rg-check">
                    <input type="checkbox" v-model="taxaRegCr.marcado">
                    <span>Taxa <small class="muted">— marcado quando o projeto tem taxa cadastrada</small></span>
                  </label>

                  <div class="rg-linha">
                    <div class="rg-campo">
                      <label>Documento do título</label>
                      <complemento-sugerido v-model="reg.cr.documento" :digitados="[reg.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                            placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                    </div>
                    <div class="rg-campo rg-campo-sm">
                      <label>Emissão</label>
                      <date-picker v-model="reg.cr.dataEmissao" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                   :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                   :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                    </div>
                    <div class="rg-campo rg-campo-sm">
                      <label>Vencimento</label>
                      <date-picker v-model="reg.cr.dataVencimento" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                   :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                   :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                    </div>
                  </div>

                  <div class="rg-linha">
                    <div class="rg-campo rg-campo-lg">
                      <label>Complemento <span class="muted">(opcional)</span></label>
                      <complemento-sugerido v-model="reg.cr.complemento" :digitados="[reg.cr.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento" :maxlength="300"
                                            placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                    </div>
                  </div>

                  <div class="rg-anexo" v-if="podeAnexarContaReceber">
                    <anexos-operacao v-model="anexos.creditoContaReceber" :limite="limiteAnexo" :origens="origensLinha"
                                     :titulo="variosCr ? 'Arquivos · título 1' : 'Arquivos do contas a receber'"
                                     dica="Os arquivos vão para a pasta do contas a receber assim que o título for criado."></anexos-operacao>
                  </div>
                  </div>

                  <div v-for="(t, i) in crExtras" :key="t.chave" class="rg-tit" :class="{ 'rg-tit-erro': crComErro(i + 1) }">
                    <div class="rg-tit-cab">
                      <span class="rg-tit-num">{{ i + 2 }}</span>
                      <span class="rg-tit-ordem">Título {{ i + 2 }} de {{ titulosRegCr.length }}</span>
                      <span v-if="crComErro(i + 1)" class="rg-tit-pendente"><i class="fa fa-exclamation-circle"></i> Pendente</span>
                      <b>{{ t.notaFiscal ? 'NF ' + t.notaFiscal.numero : 'Sem NF' }}</b>
                      <span class="rg-tit-nome">{{ t.nomeTerceiro || t.historico || '' }}</span>
                      <div class="rg-tit-valor" :class="{ 'rg-invalido': erro('crx' + (i + 1) + 'Valor') }">
                        <label>Valor</label>
                        <div class="rg-tit-valor-campo">
                          <input type="text" class="form-control mono" :value="t.valorTexto" maxlength="20" placeholder="0,00"
                                 @input="digitarValorTitulo(t, $event)" @blur="sairValorTitulo(t)">
                          <button v-if="Math.abs(faltaRegCr) >= 0.005" type="button" class="rg-tit-saldo" @click="usarFalta(t, faltaRegCr)"
                                  title="Jogar o que falta neste título"><i class="fa fa-level-down"></i></button>
                        </div>
                      </div>
                      <button type="button" class="rg-tit-remover" title="Remover este título" @click="removerCr(i)"><i class="fa fa-trash-o"></i></button>
                    </div>

                    <div class="rg-nf rg-nf-topo">
                      <label>Nota fiscal <span class="muted">(opcional)</span></label>
                      <nota-fiscal-vinculo v-model="t.notaFiscal" :id-pessoa="t.idTerceiro || 0" :nome-pessoa="t.nomeTerceiro" :permitir-outro-cliente="true"
                                           :ids-projeto="idsProjetoDe(t.rateios)" :total="valorRegCr(t)" :sugestoes="sugestoesNf"
                                           @cliente="c => clienteDaNotaFiscal(t, c)"
                                           @rateios="r => rateioDaNotaFiscal(t, r)"></nota-fiscal-vinculo>
                    </div>

                    <div class="rg-linha">
                      <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('crx' + (i + 1) + 'TipoPessoa') || erro('crx' + (i + 1) + 'Cliente') || erro('crx' + (i + 1) + 'Historico') }">
                        <label>Cliente <span class="rg-obr">*</span></label>
                        <div class="rg-tp">
                          <button type="button" :class="{ ativo: t.tipoPessoa === 1 }" @click="escolherTipoPessoaBloco(t, 1)">Pessoa física</button>
                          <button type="button" :class="{ ativo: t.tipoPessoa === 2 }" @click="escolherTipoPessoaBloco(t, 2)">Pessoa jurídica</button>
                          <button type="button" :class="{ ativo: t.tipoPessoa === 3 }" @click="escolherTipoPessoaBloco(t, 3)">Outros</button>
                        </div>
                        <input v-if="!(t.tipoPessoa > 0)" type="text" class="form-control rg-tp-espera" disabled placeholder="Escolha acima: pessoa física, jurídica ou outros">
                        <selecao-busca v-if="t.tipoPessoa > 0 && t.tipoPessoa !== 3" v-model="t.idTerceiro" :texto="t.nomeTerceiro"
                                       :buscar="buscarPessoasTitulo(t)" :placeholder="t.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                       @selecionado="o => t.nomeTerceiro = o ? o.nome : ''"></selecao-busca>
                        <complemento-sugerido v-if="t.tipoPessoa === 3" v-model="t.historico" :sugestoes="sugestoesHistorico" :cadastrados="textosHistorico" :maxlength="110"
                                              placeholder="Clique para ver o que veio no extrato"></complemento-sugerido>
                        <span v-if="erro('crx' + (i + 1) + 'TipoPessoa')" class="rg-msg">{{ erro('crx' + (i + 1) + 'TipoPessoa') }}</span>
                        <span v-else-if="erro('crx' + (i + 1) + 'Cliente')" class="rg-msg">{{ erro('crx' + (i + 1) + 'Cliente') }}</span>
                        <span v-else-if="erro('crx' + (i + 1) + 'Historico')" class="rg-msg">{{ erro('crx' + (i + 1) + 'Historico') }}</span>
                        <small v-else-if="t.tipoPessoa === 3" class="rg-dica">O título nasce sem pessoa, com este histórico.</small>
                      </div>
                      <div class="rg-campo rg-campo-lg">
                        <label>Conta do título</label>
                        <input type="text" class="form-control" :value="reg.cr.nomeConta || 'A mesma do título 1'" disabled>
                      </div>
                    </div>

                    <div class="rg-linha" v-if="usaCategoria">
                      <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('crx' + (i + 1) + 'Categoria') }">
                        <label>Categoria financeira <span v-if="categoriaObrigatoria" class="rg-obr">*</span></label>
                        <selecao-busca v-model="t.idCategoriaFinanceira" :texto="t.nomeCategoriaFinanceira"
                                       :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                       @selecionado="o => t.nomeCategoriaFinanceira = o ? o.nome : ''"></selecao-busca>
                        <span v-if="erro('crx' + (i + 1) + 'Categoria')" class="rg-msg">{{ erro('crx' + (i + 1) + 'Categoria') }}</span>
                      </div>
                    </div>

                    <rateio-projetos v-model="t.rateios" :id-conta-cript="idContaCript" :total="valorRegCr(t)"
                                     :id-conta-alvo="contaDoTituloCr" natureza="C" :validar="validar" :projetos-livres="crNaTransitoria"
                                     :desabilitado="!(contaDoTituloCr > 0)"
                                     aviso="Escolha a conta do título para informar o rateio."></rateio-projetos>

                    <label v-if="t.taxa.mostrar" class="rg-check">
                      <input type="checkbox" v-model="t.taxa.marcado">
                      <span>Taxa <small class="muted">— marcado quando o projeto tem taxa cadastrada</small></span>
                    </label>

                    <div class="rg-linha">
                      <div class="rg-campo">
                        <label>Documento do título</label>
                        <complemento-sugerido v-model="t.documento" :digitados="[t.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                              placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                      </div>
                      <div class="rg-campo rg-campo-sm">
                        <label>Emissão</label>
                        <date-picker v-model="t.dataEmissao" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                     :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                     :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                      </div>
                      <div class="rg-campo rg-campo-sm">
                        <label>Vencimento</label>
                        <date-picker v-model="t.dataVencimento" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                     :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                     :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                      </div>
                    </div>

                    <div class="rg-linha">
                      <div class="rg-campo rg-campo-lg">
                        <label>Complemento <span class="muted">(opcional)</span></label>
                        <complemento-sugerido v-model="t.complemento" :digitados="[t.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento" :maxlength="300"
                                              placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                      </div>
                    </div>

                    <div class="rg-anexo" v-if="podeAnexarContaReceber">
                      <anexos-operacao v-model="t.anexos" :limite="limiteAnexo" :origens="origensLinha"
                                       :titulo="'Arquivos · título ' + (i + 2)"
                                       dica="Os arquivos vão para a pasta do contas a receber assim que o título for criado."></anexos-operacao>
                    </div>
                  </div>

                  <div class="rg-tit-rodape">
                    <button type="button" class="rg-tit-add" @click="adicionarCr"><i class="fa fa-plus"></i> Adicionar título</button>
                    <span v-if="variosCr" class="rg-tit-soma" :class="Math.abs(faltaRegCr) < 0.005 ? 'ok' : 'falta'">
                      {{ titulosRegCr.length }} títulos · R$ {{ formatar(somaRegCr) }}
                      <template v-if="Math.abs(faltaRegCr) < 0.005"> · bate com o crédito</template>
                      <template v-else-if="faltaRegCr > 0"> · faltam R$ {{ formatar(faltaRegCr) }}</template>
                      <template v-else> · passou R$ {{ formatar(-faltaRegCr) }}</template>
                    </span>
                  </div>
                </bloco-operacao>
              </template>

              <contas-receber-vinculadas v-if="regVinculaContaReceber" v-model="reg.vinculados"
                                         :id-conta-cript="idContaCript" :total="deteccao.valor"
                                         :busca-inicial="buscaInicialCr" :sugestoes="sugestoesCr" :nome-transitoria="contaTransitoria"
                                         :validar="validar"></contas-receber-vinculadas>

              <template v-if="regExigeTransferencia">
                <bloco-operacao :selo="seloTransferencia" :cor="corTransferencia" :titulo="tituloTransferencia"
                                :subtitulo="subtituloTransferenciaCredito">
                  <div class="rg-seg">
                    <button type="button" :class="{ ativo: !viaSolicitacao }" @click="viaSolicitacao = false">Lançar agora</button>
                    <button type="button" :class="{ ativo: viaSolicitacao }" @click="viaSolicitacao = true">Pedir liberação</button>
                  </div>
                  <div class="rg-seg-aj">
                    <template v-if="viaSolicitacao">
                      O crédito e o débito na TRA são gerados agora e a linha do extrato concilia.
                      <template v-if="quantasOrigens > 1">
                        As {{ quantasOrigens }} solicitações ficam aguardando liberação e viram lançamento quando forem liberadas.
                      </template>
                      <template v-else>
                        A transferência fica aguardando liberação e vira lançamento quando for liberada.
                      </template>
                    </template>
                    <template v-else-if="quantasOrigens > 1">
                      Gera as pernas das {{ quantasOrigens }} transferências junto com os lançamentos acima.
                    </template>
                    <template v-else>Gera as duas pernas da transferência junto com os lançamentos acima.</template>
                  </div>

                  <div class="rg-linha">
                    <div class="rg-campo rg-campo-lg">
                      <label>Conta de origem da transferência</label>
                      <selecao-busca v-model="reg.idContaOrigem" :texto="reg.nomeContaOrigem" :buscar="buscarContasGerais"
                                     placeholder="Conta de onde o dinheiro sai..."
                                     @selecionado="o => reg.nomeContaOrigem = o ? o.nome : ''"></selecao-busca>
                      <small class="rg-dica">{{ origemRegAlterada
                        ? 'A TRA resolve em ' + nomeContaExtrato + ', mas a transferência sai de ' + nomeContaOrigemReg + '.'
                        : 'A própria conta do extrato. Troque quando o dinheiro já tiver sido levado para outra conta.' }}</small>
                    </div>
                    <div class="rg-campo rg-campo-sm">
                      <label>Data</label>
                      <date-picker v-model="form.data" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                   :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                   :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                    </div>
                  </div>

                  <origens-transferencia v-model="reg.destinos" :id-conta-cript="idContaCript"
                                         :id-conta-extrato="idContaOrigemReg" :total="deteccao.valor"
                                         :com-rateio="false" titulo="Conta de destino"
                                         :buscar="buscarContas" :validar="validar" :com-observacao="viaSolicitacao"
                                         :anexo="anexoTransferencia"
                                         @conta-escolhida="aoEscolherContaDestino"
                                         @valido="v => destinosValidos = v"></origens-transferencia>

                  <div class="rg-linha" v-if="viaSolicitacao">
                    <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('liberador') }">
                      <label>Quem vai liberar <span class="rg-obr">*</span></label>
                      <selecao-busca v-model="form.idUsuarioLiberacao" :texto="form.nomeUsuarioLiberacao" :buscar="buscarUsuarios"
                                     placeholder="Buscar responsável pela liberação..."
                                     @selecionado="o => form.nomeUsuarioLiberacao = o ? o.nome : ''"></selecao-busca>
                      <span v-if="erro('liberador')" class="rg-msg">{{ erro('liberador') }}</span>
                    </div>
                    <div v-if="!observacaoPorConta" class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('observacao') }">
                      <label>Observação <span class="rg-obr">*</span></label>
                      <input type="text" class="form-control" maxlength="300" v-model="form.observacao"
                             placeholder="Motivo da transferência">
                      <span v-if="erro('observacao')" class="rg-msg">{{ erro('observacao') }}</span>
                    </div>
                  </div>
                </bloco-operacao>
              </template>
            </div>
          </template>

        </div>

        <div class="rg-lateral">
          <div class="rg-lat-cab">
            <span class="rg-lat-tit">O que será gerado</span>
            <span v-if="operacao" class="rg-lat-selo" :class="conciliaAgora ? 'rg-lat-selo-ok' : 'rg-lat-selo-pend'">
              {{ ehSaldo ? 'Concilia sem extrato' : (conciliaAgora ? 'Concilia o extrato' : 'Extrato pendente') }}
            </span>
          </div>
          <div class="rg-lat-resumo">{{ resumoPrevia }}</div>

          <div v-for="g in gruposPrevia" :key="g.chave" class="rg-grupo">
            <div v-if="gruposPrevia.length > 1" class="rg-grupo-tit">{{ g.titulo }}</div>
            <div v-for="i in g.itens" :key="i.chave" class="rg-card">
              <span class="rg-mk" :class="'rg-mk-' + i.cor">
                <i v-if="i.mk.icone" class="fa" :class="i.mk.icone"></i>
                <template v-else>{{ i.mk.texto }}</template>
              </span>
              <div class="rg-card-txt">
                <div class="rg-card-topo">
                  <span class="rg-card-rot">{{ i.rotulo }}</span>
                  <span class="rg-card-val mono">R$ {{ formatar(i.valor) }}</span>
                </div>
                <div class="rg-card-linha">{{ i.linha }}</div>
                <div class="rg-card-nota">{{ i.nota }}</div>
              </div>
            </div>
          </div>

          <div v-if="ehCreditoIdentificar && configCredito" class="rg-lat-cfg">
            <div class="rg-lat-cfg-tit">Da configuração</div>
            <div class="rg-lat-cfg-item"><b>Projeto</b> {{ configCredito.nomeProjeto || '—' }}</div>
            <div class="rg-lat-cfg-item"><b>Conta transitória</b> {{ configCredito.nomeConta || '—' }}</div>
            <div class="rg-lat-cfg-item"><b>Rubrica do crédito</b> {{ rubricaCredito || '—' }}</div>
            <div class="rg-lat-cfg-item"><b>Rubrica do débito</b> {{ rubricaDebito || '—' }}</div>
          </div>
        </div>

      </div>

      <div class="rg-foot">
        <div class="rg-foot-l">
          Valor R$ {{ formatar(deteccao.valor) }}
          <span class="rg-pt">·</span>
          {{ totalLancamentos }} lançamento<span v-if="totalLancamentos !== 1">s</span>
          <template v-if="totalAnexos > 0">
            <span class="rg-pt">·</span>
            {{ totalAnexos }} arquivo<span v-if="totalAnexos !== 1">s</span>
          </template>
          <button v-if="validar && Object.keys(erros).length > 0" type="button" class="rg-foot-erros" @click="irParaPrimeiroErro">
            <i class="fa fa-exclamation-circle"></i>
            {{ Object.keys(erros).length }} pendência<span v-if="Object.keys(erros).length !== 1">s</span> — ver
          </button>
        </div>
        <div class="rg-foot-r">
          <button class="btn-primary" :disabled="gravando || !operacao" @click="confirmar">
            <i class="fa" :class="gravando ? 'fa-spinner fa-pulse' : 'fa-check'"></i> {{ rotuloBotao }}
          </button>
          <button class="rd-btn rd-sair" @click="fechar"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
  .ov { position: fixed; inset: 0; background: rgba(16,24,40,.55); z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .ov-modal { background: #fff; border-radius: 8px; width: 96vw; max-width: 1180px; max-height: 94vh; display: flex; flex-direction: column; box-shadow: 0 10px 40px rgba(16,24,40,.2); overflow: hidden; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
  .muted { color: #8a939c; font-weight: normal; }

  .rg-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; padding: 15px 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; }
  .rg-head h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .rg-sub { display: flex; align-items: center; gap: 7px; margin-top: 4px; font-size: 12px; color: #6b747e; min-width: 0; }
  .rg-hist { max-width: 460px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rg-qtd-linhas { font-weight: 600; color: #3b444d; }
  .rg-linhas-ext { flex: 0 0 auto; max-height: 132px; overflow-y: auto; margin: 10px 20px; border: 1px solid #e6e9ed; border-radius: 6px; background: #fafbfc; }
  .rg-linha-ext { display: flex; align-items: center; gap: 12px; padding: 5px 10px; font-size: 12px; border-bottom: 1px solid #f0f2f4; }
  .rg-linha-ext:last-child { border-bottom: none; }
  .rg-linha-ext-hist { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #3b444d; }
  .rg-linha-ext-valor { flex: none; min-width: 90px; text-align: right; color: #3b444d; }
  .rg-linha-ext-soma { font-weight: 600; border-top: 1px solid #dbe3ec; }
  .rg-boleto-ok { color: #0a6d4d; }
  .rg-mov-cab { margin-bottom: 10px; }
  .rg-pt { color: #b6bdc5; }
  .rg-valor { text-align: right; flex: none; }
  .rg-valor-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #8a939c; }
  .rg-valor-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 22px; font-weight: 600; margin-top: 2px; }
  .rg-valor-cre { color: #0a6d4d; }
  .rg-valor-deb { color: #a13c3c; }

  .rg-corpo { flex: 1 1 auto; min-height: 0; display: grid; grid-template-columns: 1fr 340px; gap: 0; overflow: hidden; }
  .rg-passos { overflow: auto; padding: 16px 20px 20px; }
  .rg-lateral { overflow: auto; padding: 16px 18px 20px; background: #fafbfc; border-left: 1px solid #e6e9ed; }

  .rg-barra { flex: 0 0 auto; padding: 12px 20px 13px; background: #fff; border-bottom: 1px solid #e6e9ed; }
  .rg-barra-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #8a939c; margin-bottom: 7px; }
  .rg-abas { display: flex; flex-wrap: wrap; gap: 7px; }
  .rg-aba { display: inline-flex; align-items: center; gap: 7px; height: 34px; padding: 0 15px; background: #fff; border: 1px solid #dfe3e8; border-radius: 6px; font-size: 12.5px; color: #5b6570; }
  .rg-aba .fa { font-size: 12px; color: #9aa3ac; }
  .rg-aba:hover { background: #f4f6f8; border-color: #c6ccd4; }
  .rg-aba.ativa { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; font-weight: 600; box-shadow: 0 0 0 1px rgba(15,138,95,.18); }
  .rg-aba.ativa .fa { color: #0f8a5f; }
  .rg-aba:focus { outline: 2px solid #2d6cb3; outline-offset: 2px; }
  .rg-aba:focus:not(:focus-visible) { outline: none; }
  .rg-barra-aj { margin-top: 8px; font-size: 12px; color: #6b747e; line-height: 1.45; }
  .rg-barra-aj b { color: #3b444d; font-weight: 600; }

  .rg-passo { margin-bottom: 18px; }
  .rg-passo:last-child { margin-bottom: 0; }
  .rg-passo-tit { font-size: 13px; font-weight: 600; color: #1c2024; margin-bottom: 9px; }
  .rg-passo-tit-acao { display: flex; justify-content: space-between; align-items: center; }
  .rg-recarregar { height: 26px; padding: 0 10px; background: #1c84c6; border: 1px solid #1c84c6; border-radius: 5px; font-size: 12px; font-weight: 500; color: #fff; }
  .rg-recarregar:hover:not(:disabled) { background: #1a7bb9; border-color: #1a7bb9; color: #fff; }
  .rg-recarregar:disabled { opacity: .6; }

  .rg-chips { display: flex; flex-wrap: wrap; gap: 6px; }
  .rg-chip { height: 30px; padding: 0 13px; background: #fff; border: 1px solid #dfe3e8; border-radius: 6px; font-size: 12px; color: #5b6570; }
  .rg-chip:hover { background: #f4f6f8; border-color: #c6ccd4; }
  .rg-chip.ativo { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; font-weight: 600; }
  .rg-chips-aj { margin-top: 7px; font-size: 11.5px; color: #7b848e; line-height: 1.45; }
  .rg-chips-aj b { color: #3b444d; font-weight: 600; }

  .rg-caixa { border: 1px solid #e6e9ed; border-radius: 7px; padding: 13px 14px; background: #fff; }
  .rg-seg-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #8a939c; margin-bottom: 5px; }
  .rg-seg { display: inline-flex; border: 1px solid #c6ccd4; border-radius: 5px; overflow: hidden; }
  .rg-seg button { height: 32px; padding: 0 16px; background: #fff; border: none; border-left: 1px solid #e2e6ea; font-size: 12.5px; color: #5b6570; }
  .rg-seg button:first-child { border-left: none; }
  .rg-seg button:hover { background: #f4f6f8; }
  .rg-seg button.ativo { background: #e8f5ef; color: #0a6d4d; font-weight: 600; box-shadow: inset 0 -2px 0 #0f8a5f; }
  .rg-seg-aj { font-size: 11.5px; color: #7b848e; line-height: 1.45; margin: 7px 0 12px; }
  .rg-aviso-item { font-size: 11.5px; color: #8a6d1f; background: #fdf6e3; border: 1px solid #f0e2bb;
                   border-radius: 4px; padding: 7px 10px; line-height: 1.45; margin: 8px 0 2px; }
  .rg-aviso-dias { flex: 0 0 auto; margin: -4px 20px 10px; }
  .rg-seg-aj b { color: #8a6d1f; }

  .rg-sub-tit { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; margin: 16px 0 9px; padding-top: 13px; border-top: 1px solid #eef1f4; }

  .rg-linha { display: flex; gap: 10px; margin-bottom: 10px; }
  .rg-linha:last-child { margin-bottom: 0; }
  .rg-campo { flex: 1 1 0; min-width: 0; }
  .rg-campo-lg { flex: 2 1 0; }
  .rg-campo-sm { flex: 0 0 148px; }
  .rg-campo label { display: block; font-size: 13px; font-weight: 700; color: #676a6c; margin-bottom: 5px; }
  .rg-obr { color: #ED5565; }
  .rg-tp { display: flex; border: 1px solid #c6ccd4; border-radius: 5px; overflow: hidden; height: 32px; margin-bottom: 6px; }
  .rg-tp-espera { cursor: not-allowed; }
  .rg-tp button { flex: 1; border: none; background: #fff; color: #5b6570; font-size: 12.5px; padding: 0 8px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .rg-tp button:first-child { border-left: none; }
  .rg-tp button:hover { background: #f4f6f8; }
  .rg-tp button.ativo { background: #e8f5ef; color: #0a6d4d; font-weight: 600; box-shadow: inset 0 -2px 0 #0f8a5f; }

  .rg-nf { margin-top: 10px; }
  .rg-nf-topo { margin: 0 0 12px; padding-bottom: 12px; border-bottom: 1px dashed #e1e6eb; }
  .rg-tit { border: 1px solid #dbe3ec; border-left: 3px solid #2f6fb2; border-radius: 6px; padding: 0 12px 12px; margin-top: 12px; background: #fff; }
  .rg-tit-primeiro { margin-top: 0; }
  .rg-tit-cab { display: flex; align-items: center; gap: 10px; margin: 0 -12px 10px; padding: 6px 12px; background: #f2f6fa; border-bottom: 1px solid #e3e8ef; border-radius: 0 5px 0 0; }
  .rg-tit-ordem { flex: none; font-size: 10.5px; text-transform: uppercase; letter-spacing: .04em; color: #64748b; font-weight: 600; white-space: nowrap; }
  .rg-tit-cab b { font-size: 13px; color: #1c2024; white-space: nowrap; align-self: center; }
  .rg-tit-num { flex: none; align-self: center; width: 22px; height: 22px; border-radius: 11px; background: #dfeaf7; color: #2f6fb2; font-size: 12px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; }
  .rg-tit-nome { flex: 1 1 auto; min-width: 0; align-self: center; font-size: 12.5px; color: #5b6570; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rg-tit-valor { flex: none; margin-left: auto; display: flex; align-items: center; gap: 8px; }
  .rg-tit-valor label { font-size: 11.5px; font-weight: 600; color: #4b545e; margin: 0; }
  .rg-tit-valor-campo { width: 140px; }
  .rg-tit-valor .form-control { height: 30px; text-align: right; padding-right: 22px; }
  .rg-tit-valor-campo { position: relative; }
  .rg-tit-saldo { position: absolute; right: 3px; top: 50%; transform: translateY(-50%); border: 0; background: none;
                  color: #8b97a5; padding: 0 2px; font-size: 11px; cursor: pointer; }
  .rg-tit-saldo:hover { color: #2f6fb2; }
  .rg-tit-valor.rg-invalido .form-control { border-color: #d9534f; }
  .rg-tit-remover { flex: none; border: 0; background: none; color: #b0bac5; cursor: pointer; padding: 2px 4px; font-size: 14px; }
  .rg-tit-remover:hover { color: #c0392b; }
  .rg-tit-rodape { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 14px; margin-top: 12px; }
  .rg-tit-add { height: 28px; padding: 0 11px; background: #fff; border: 1px dashed #0f8a5f; border-radius: 5px; font-size: 12px; font-weight: 600; color: #0a6d4d; }
  .rg-tit-add:hover { background: #e8f5ef; }
  .rg-compl-tit { border-left-color: #8a939c; background: #f7f9fa; }
  .rg-compl-cadeado { color: #8a939c; }
  .rg-compl-valor { margin-left: auto; font-weight: 600; }
  .rg-compl-info { display: flex; gap: 16px; font-size: 12px; color: #3b444d; padding: 2px 0 6px; }
  .rg-compl-rateio { width: 100%; font-size: 12px; border-collapse: collapse; }
  .rg-compl-rateio th { font-weight: 600; color: #6b747e; text-align: left; padding: 3px 6px; border-bottom: 1px solid #e6e9ed; }
  .rg-compl-rateio td { padding: 3px 6px; color: #3b444d; border-bottom: 1px solid #f0f2f4; }
  .rg-compl-rateio .num { text-align: right; white-space: nowrap; }
  .rg-compl-resumo { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin-top: 12px; font-size: 12px; color: #3b444d; }
  .rg-compl-ok { font-weight: 600; color: #0a6d4d; }
  .rg-compl-falta { font-weight: 600; color: #a13c3c; }
  .rg-tit-soma { font-size: 12px; font-weight: 600; padding: 4px 9px; border-radius: 5px; }
  .rg-tit-soma.ok { background: #e8f5ef; color: #0a6d4d; }
  .rg-tit-soma.falta { background: #fbeeee; color: #a13c3c; }
  .rg-aviso-pagador { margin-top: 6px; font-size: 11.5px; font-weight: 600; color: #8a5a00; background: #fdf3e1; border-radius: 4px; padding: 4px 8px; }
  .rg-nf > label { display: block; font-size: 13px; font-weight: 700; color: #676a6c; margin-bottom: 5px; }
  .rg-dica { display: block; margin-top: 4px; font-size: 11.5px; color: #8a939c; }
  .rg-anexo { margin-top: 12px; padding-top: 12px; border-top: 1px solid #eef1f4; }

  .rg-opcoes { display: flex; gap: 10px; margin-bottom: 12px; }
  .rg-radio { flex: 1; display: flex; align-items: flex-start; gap: 8px; margin: 0; padding: 10px 12px; border: 1px solid #dfe3e8; border-radius: 7px; font-weight: normal; cursor: pointer; }
  .rg-radio:hover { background: #f7f9fa; }
  .rg-radio input { margin: 2px 0 0; }
  .rg-radio b { display: block; font-size: 12.5px; color: #2a3038; }
  .rg-radio small { display: block; font-size: 11.5px; color: #8a939c; margin-top: 2px; }
  .rg-radio-on { border-color: #0f8a5f; background: #f4faf7; box-shadow: inset 0 0 0 1px #0f8a5f; }

  .rg-msg { display: block; margin-top: 4px; font-size: 12.5px; color: #ED5565; }
  .rg-msg-bloco { margin: 0 0 8px; }

  .rg-check { display: flex; align-items: center; gap: 8px; margin: 12px 0 0; font-weight: normal; font-size: 12.5px; color: #3b444d; cursor: pointer; }
  .rg-check input { margin: 0; }

  .rg-alerta { background: #fff8e6; border: 1px solid #f0dfae; border-radius: 6px; padding: 10px 12px; font-size: 12.5px; color: #8a6d1f; line-height: 1.5; margin-bottom: 10px; }
  .rg-vazio { padding: 30px; text-align: center; color: #8a939c; }
  .rg-escolha { padding: 50px 30px; font-size: 13px; line-height: 1.7; }
  .rg-escolha b { color: #3b444d; }
  .rg-escolha-ic { display: block; font-size: 28px; color: #c6ccd4; margin-bottom: 10px; }

  .apl-lista { border: 1px solid #eceef1; border-radius: 6px; max-height: 32vh; overflow: auto; margin-bottom: 12px; }
  .apl-head { display: flex; align-items: center; gap: 10px; padding: 7px 12px 7px 33px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #8a939c; position: sticky; top: 0; }
  .apl-item { display: flex; align-items: center; gap: 10px; padding: 8px 12px; margin: 0; font-weight: normal; border-bottom: 1px solid #f2f3f5; cursor: pointer; font-size: 12.5px; }
  .apl-item:last-child { border-bottom: none; }
  .apl-item:hover { background: #f7f9fa; }
  .apl-item.sel { background: #eef9f4; }
  .apl-item input { margin: 0; flex: none; width: 13px; }
  .apl-tipo { flex: 1 1 0; min-width: 0; font-weight: 600; color: #1c2024; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .apl-proj { flex: 1 1 0; min-width: 0; color: #6b747e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .apl-data { flex: 0 0 76px; color: #8a939c; }
  .apl-valor { flex: 0 0 106px; text-align: right; color: #6b747e; }
  .apl-saldo { flex: 0 0 118px; text-align: right; color: #0a6d4d; font-weight: 600; }
  .apl-head .apl-tipo, .apl-head .apl-proj { font-weight: 600; color: #8a939c; }
  .apl-head .apl-valor, .apl-head .apl-saldo { font-weight: 600; color: #8a939c; }

  .rg-lat-cab { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
  .rg-lat-tit { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #7b848e; }
  .rg-lat-selo { flex: none; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; border-radius: 10px; padding: 3px 9px; }
  .rg-lat-selo-ok { background: #e3f3ec; color: #0a6d4d; }
  .rg-lat-selo-pend { background: #fdf3e0; color: #8a6d1f; }
  .rg-lat-resumo { font-size: 12px; color: #6b747e; line-height: 1.5; margin: 6px 0 13px; }

  .rg-grupo { margin-bottom: 13px; }
  .rg-grupo:last-child { margin-bottom: 0; }
  .rg-grupo-tit { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #9aa3ac; margin-bottom: 6px; }
  .rg-card { display: flex; gap: 9px; background: #fff; border: 1px solid #e6e9ed; border-radius: 6px; padding: 9px 11px; margin-bottom: 7px; }
  .rg-card:last-child { margin-bottom: 0; }
  .rg-card-txt { flex: 1 1 auto; min-width: 0; }
  .rg-mk { flex: none; display: inline-flex; align-items: center; justify-content: center; width: 21px; height: 21px; margin-top: 1px; border-radius: 5px; font-size: 10.5px; font-weight: 700; }
  .rg-mk .fa { font-size: 10px; }
  .rg-mk-cre { background: #e3f3ec; color: #0a6d4d; }
  .rg-mk-deb { background: #fbeceb; color: #a13c3c; }
  .rg-mk-azu { background: #e7effa; color: #2d6cb3; }
  .rg-mk-amb { background: #fdf3e0; color: #8a6d1f; }
  .rg-card-topo { display: flex; justify-content: space-between; align-items: baseline; gap: 10px; }
  .rg-card-rot { font-size: 11.5px; font-weight: 600; color: #3b444d; }
  .rg-card-val { font-size: 13px; font-weight: 600; color: #1c2024; }
  .rg-card-linha { font-size: 12.5px; color: #1c2024; margin-top: 3px; line-height: 1.35; }
  .rg-card-nota { font-size: 11.5px; color: #8a939c; margin-top: 2px; line-height: 1.4; }

  .rg-lat-cfg { margin-top: 14px; padding-top: 12px; border-top: 1px solid #e6e9ed; }
  .rg-lat-cfg-tit { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #7b848e; margin-bottom: 7px; }
  .rg-lat-cfg-item { font-size: 11.5px; color: #5b6570; line-height: 1.5; margin-bottom: 3px; }
  .rg-lat-cfg-item b { display: block; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #9aa3ac; }

  .rg-foot { flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 12px 20px; background: #f7f9fa; border-top: 1px solid #e6e9ed; }
  .rg-foot-l { font-size: 12px; color: #6b747e; }
  .rg-foot-r { display: flex; gap: 8px; }

  .btn-primary { height: 34px; padding: 0 20px; background: #0f8a5f; border: 1px solid #0d7a54; color: #fff; font-size: 13px; font-weight: 600; border-radius: 5px; box-shadow: 0 1px 2px rgba(15,138,95,.3); }
  .btn-primary:hover { background: #0d7a54; }
  .btn-primary:disabled { opacity: .6; }
  .rd-btn { display: inline-flex; align-items: center; gap: 7px; background: #fff; border: 1px solid #c6ccd4; border-radius: 5px; padding: 8px 14px; font-size: 12.5px; color: #3b444d; }
  .rd-btn:hover { background: #f4f6f8; }
  .rd-sair { background: #fdf1f1; border-color: #e4d7d7; color: #a13c3c; font-weight: 600; padding: 8px 18px; }
  .rd-sair:hover { background: #fbe7e7; border-color: #d9c2c2; }
</style>

<style>
  .reg-modal .mx-datepicker input { height: 34px; padding-right: 30px; border: 1px solid #d2d6db; border-radius: 2px; box-shadow: none;
                         font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 13px; }
  .reg-modal .rg-campo .form-control,
  .reg-modal .rg-nf .form-control { height: 34px; font-size: 13px; border: 1px solid #d2d6db; border-radius: 2px; box-shadow: none; color: #676a6c; }
  .reg-modal .form-control,
  .reg-modal .mx-datepicker input { border-color: #d2d6db; }
  .reg-modal .rg-campo .form-control:focus,
  .reg-modal .rg-nf .form-control:focus,
  .reg-modal .mx-datepicker input:focus { border-color: #1ab394; }
  .reg-modal .form-control[readonly],
  .reg-modal .form-control[disabled],
  .reg-modal .mx-datepicker input[disabled] { background: #eee; color: #676a6c; }
  .reg-modal .form-control::placeholder,
  .reg-modal .mx-datepicker input::placeholder { color: #a5aab0; }
  .reg-modal .rg-invalido .form-control,
  .reg-modal .rg-invalido .mx-datepicker input,
  .reg-modal .rg-invalido .rg-tp { border-color: #ED5565 !important; background: #fff8f8; box-shadow: 0 0 0 3px rgba(237,85,101,.2) !important; }
  .reg-modal .rg-invalido > label { color: #ED5565 !important; }
  .reg-modal .rt-erro .form-control,
  .reg-modal .og-invalido .form-control,
  .reg-modal .pt-invalido .form-control { border-color: #ED5565 !important; background: #fff8f8; box-shadow: 0 0 0 3px rgba(237,85,101,.2) !important; }
  .rg-tit.rg-tit-erro { border-color: #e8b4ae; border-left-color: #c0392b; }
  .rg-tit-pendente { font-size: 11px; font-weight: 600; color: #c0392b; background: #fdecea; border-radius: 10px; padding: 1px 8px; white-space: nowrap; }
  .rg-foot-erros { margin-left: 12px; border: none; background: #fdecea; color: #c0392b; font-size: 12px; font-weight: 600; border-radius: 12px; padding: 3px 10px; cursor: pointer; }
  .rg-foot-erros:hover { background: #f9d9d5; }
  .rg-invalido .rg-tp { border-color: #ED5565; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/RegularizarModal.vue